if ($(".type-product").length) {
    var Url = window.location.pathname,
        Name = $(".p-data-wrapper .p-detail-inner-header h1").text(),
        Price = $(".p-data-wrapper .p-final-price-wrapper").html(),
        Img = $(".p-image a img").attr("src"),
        Parametr = $('.extended-description .detail-parameters tr:contains("Perex:") td').html(),
        Stitek = $(".p-image .flags").html(),
        Skaldovost = $('.availability-label:not(".no-display")').closest("td").html().trim(),
        ArrIn = [Url, Name, Img, Price, Parametr, Stitek, Skaldovost];
    if (JSON.parse(localStorage.getItem("naposledy_prohlizene"))) {
        Arr = JSON.parse(localStorage.getItem("naposledy_prohlizene"));
        for (var a = 0; a < Arr.length; a++)
            Arr[a].includes(Url) && Arr.splice(a, 1);
        Arr.unshift(ArrIn),
        Arr.length > 4 && Arr.pop(),
        localStorage.setItem("naposledy_prohlizene", JSON.stringify(Arr))
    } else {
        var Arr = [ArrIn];
        localStorage.setItem("naposledy_prohlizene", JSON.stringify(Arr))
    }
}
if (JSON.parse(localStorage.getItem("naposledy_prohlizene")))
    Arr = JSON.parse(localStorage.getItem("naposledy_prohlizene"));
else
    Arr = "";
if (Arr.length) {
    $(".in-index").length && $(".products-wrapper").append('<div id="RecentlyViewed" class="RecentlyViewed"><h2>Poslední navštívené produkty</h2><div class="ReViIn products-block products"></div></div>'),
    $(".type-category").length && $("main#content").append('<div id="RecentlyViewed" class="RecentlyViewed"><h2>Poslední navštívené produkty</h2><div class="ReViIn products-block products"></div></div>'),
    $(".type-detail").length && $("main#content").append('<div id="RecentlyViewed" class="RecentlyViewed"><h2>Poslední navštívené produkty</h2><div class="ReViIn products-block products"></div></div>');
    for (var i = 0; i < Arr.length; i++)
        $(".ReViIn").append('<div class="product naposledy-navs"><div class="p"><a class="image" href="' + Arr[i][0] + '"><img src="' + Arr[i][2] + '"><div class="flags-default flags">' + Arr[i][5] + '</div></a><div class="p-in"><div class="p-in-in"><a class="name" href="' + Arr[i][0] + '">' + Arr[i][1] + '</a></div><div class="p-bottom"><div><div class="prices"><div class="price">' + Arr[i][3] + '</div></div><div class="availability">' + Arr[i][6] + "</div></div></div></div></div>");
    $(".ReViIn .flags").each((function() {
        $(this).text().match("undefined") && $(this).remove(),
        $(this).text().match("null") && $(this).remove()
    })),
    $(".ReViInPrPrice").each((function() {
        $(this).text().match("undefined") && $(this).remove(),
        $(this).text().match("null") && $(this).remove()
    }))
}

   /*
if ("yes" == favorite) {
    favorite_url = "/oblibene/",
    favorite_url_class = "in-oblibene",
    favorite_text = "Do oblíbených";
    function compare(e, t) {
        if (void 0 !== window.localStorage) {
            var a = JSON.parse(localStorage.getItem(e));
            null == a && (a = []);
            t = $('#product-detail-form meta[itemprop="sku"]').attr("content");
            for (var i = 0; i < a.length; i++)
                if (a[i].id == t) {
                    $(".p-image .favotire-detail").toggleClass("fav-yes"),
                    i;
                    break
                }
        }
    }
    function fav_local(e, t, a, i, n, o, r, s, l) {
        if (void 0 !== window.localStorage) {
            var d = JSON.parse(localStorage.getItem(e));
            null == d && (d = []);
            for (var c = -1, p = 0; p < d.length; p++)
                if (d[p].id == t) {
                    var u = d[p].id;
                    c = p;
                    break
                }
            if (-1 == c) {
                var h = t,
                    m = i,
                    v = n,
                    f = a,
                    $ = o,
                    g = r,
                    k = s,
                    b = l,
                    _ = new Date;
                _.setTime(_.getTime());
                var y = {
                    id: h,
                    title: m,
                    slug: v,
                    complete: f,
                    image: $,
                    flagsextra: g,
                    flagsdefault: k,
                    pin: b,
                    date: _.toGMTString()
                };
                d.push(y);
                var w = d.sort((function(e, t) {
                    var a = new Date(e.date);
                    return new Date(t.date) - a
                }));
                50 === Object.keys(w).length && w.pop(),
                localStorage.setItem(e, JSON.stringify(w))
            } else {
                var x = d.map((function(e) {
                    return e.id
                })).indexOf(u);
                d.splice(x, 1),
                localStorage.setItem(e, JSON.stringify(d))
            }
        }
    }
    if (variableyes = localStorage.getItem("products_fav"), $("header#header .navigation-buttons, .responsive-tools").prepend('<a href="' + favorite_url + '" class="favorite"><i class="favorite_icon"><svg width="28px" height="24px" viewBox="0 0 28 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="hlavicka" transform="translate(-1270.000000, -84.000000)" fill="#fff" fill-rule="nonzero"><g id="like-9" transform="translate(1270.000000, 84.000000)"><path d="M25.1840611,2.3576166 C23.8441662,0.837268531 21.9853558,0 19.9501247,0 C17.0877063,0 15.2754815,1.7095559 14.2592986,3.1437364 C13.9956492,3.51589112 13.7713694,3.88905396 13.5830636,4.24019738 C13.3947578,3.88905396 13.1705311,3.51589112 12.9068287,3.1437364 C11.8906457,1.7095559 10.078421,0 7.21600255,0 C5.18077148,0 3.32196105,0.83732159 1.98201305,2.35766966 C0.70393166,3.80798005 0,5.75035815 0,7.82697512 C0,10.087441 0.882527723,12.1898976 2.7773651,14.4434127 C4.47084417,16.4575264 6.90714703,18.5336128 9.72833873,20.9376559 C10.7795936,21.8335014 11.8667162,22.7599087 13.0240887,23.7725367 L13.0588423,23.8029925 C13.2088927,23.9343662 13.3959781,24 13.5830636,24 C13.7701491,24 13.9572346,23.9343132 14.107285,23.8029925 L14.1420385,23.7725367 C15.299411,22.7599087 16.3865337,21.8335544 17.4379477,20.9375497 C20.2589802,18.5336658 22.6952831,16.4575795 24.3887621,14.4434127 C26.2835995,12.1898445 27.1661272,10.087441 27.1661272,7.82697512 C27.1661272,5.75035815 26.4621956,3.80798005 25.1840611,2.3576166 Z M16.4054226,19.7261103 C15.4991776,20.4983286 14.5665093,21.293097 13.5830636,22.1480342 C12.599671,21.2932032 11.6669496,20.4983817 10.7605454,19.7260041 C5.23929538,15.0211174 1.59176527,11.9128774 1.59176527,7.82697512 C1.59176527,6.13811217 2.15445429,4.56948055 3.17620842,3.41009179 C4.20968854,2.23754444 5.64434658,1.59176527 7.21600255,1.59176527 C9.39825967,1.59176527 10.8089351,2.93617021 11.6080013,4.06398896 C12.3247732,5.07550273 12.698785,6.09518756 12.8263384,6.48660264 C12.9330397,6.81424099 13.2384995,7.0359739 13.5830636,7.0359739 C13.9276277,7.0359739 14.2330875,6.81424099 14.3397888,6.48660264 C14.4673423,6.09518756 14.8413541,5.07550273 15.558126,4.0639359 C16.3571921,2.93617021 17.7678676,1.59176527 19.9501247,1.59176527 C21.5217807,1.59176527 22.9564387,2.23754444 23.9898658,3.41009179 C25.0116729,4.56948055 25.574362,6.13811217 25.574362,7.82697512 C25.574362,11.9128774 21.9268319,15.0211174 16.4054226,19.7261103 Z" id="Shape" class="btn_toggle"></path></g></g></g></svg><span class="number"></span></i></a>'), variableyes ? $("header#header .favorite_icon .number").html(JSON.parse(localStorage.getItem("products_fav")).length) : $("header#header .favorite_icon .number").html(""), $(document).ready((function() {
        var e = JSON.parse(localStorage.getItem("products_fav"));
        (null == e && (e = []), $(".type-detail").length && $(".p-image-wrapper").each((function() {
            
            for (var t = $(this).closest("#product-detail-form").find('meta[itemprop="sku"]').attr("content"), a = 0; a < e.length; a++)
                if (e[a].id == t) {
                    a,
                    $(this).closest(".favorite").addClass("fav-active");
                    break
                }
        })), $(".product").each((function() {
            $(this).find(".p").append('<span class="favorite"><i class="add_favorite"><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20"><path d="M21.317,3.761a5.581,5.581,0,0,0-8.14,0L12,4.994l-1.177-1.23a5.581,5.581,0,0,0-8.14,0,6.211,6.211,0,0,0,0,8.5L3.862,13.5v0L12,22h0l8.138-8.5v0l1.177-1.23A6.211,6.211,0,0,0,21.317,3.761Z" class="btn_toggle" data-id="317"></path></svg></i></span>');
            for (var t = $(this).find('span[data-micro="sku"]').text(), a = 0; a < e.length; a++)
                if (e[a].id == t) {
                    a,
                    $(this).closest(".product").addClass("fav-active");
                    break
                }
        })), $(".products .product .btn_toggle").click((function() {
            $(this).closest(".product").toggleClass("fav-active");
            var e = $(this).closest(".product").html();
            fav_local("products_fav", $(this).closest(".product").find('span[data-micro="sku"]').text(), e, $(this).closest(".product").find("p-in-in").html(), $(this).closest(".product").find("a.name").attr("href"), $(this).closest(".product").find("a.image").html().trim(), $(this).closest(".product").find(".flags.flags-default").html(), $(this).closest(".product").find(".flags.flags-extra").html(), $(this).closest(".product").find(".p-in").html()),
            $("header#header .favorite_icon .number").html(JSON.parse(localStorage.getItem("products_fav")).length)
        })), $(".oblibene-doprava .btn_toggle").click((function() {
            $(".oblibene-doprava .favotire-detail").toggleClass("fav-yes");
            var e = $(this).closest(".p-detail-inner").find('.p-data-wrapper #product-detail-form meta[itemprop="sku"]').attr("content"),
                t = window.location.pathname;
            if ($("#variants, #simple-variants, .variant-list").length)
                var a = '<div class="p" data-micro="product"><a href="' + t + '" class="image">' + $(".p-main-image").html() + '</a><div class="p-in"><div class="p-in-in"><a href="' + t + '" class="name" data-micro="url"><span data-micro="name">' + $(".p-detail-inner-header h1").text() + '</span> </a><div class="ratings-wrapper"><div class="stars-wrapper"></div><div class="availability"></div></div></div><div class="p-bottom"><div data-micro="offer" data-micro-price="' + $(".p-final-price-wrapper").text() + '" data-micro-price-currency="CZK" data-micro-warranty="2 roky"><div class="prices">' + $(".p-final-price-wrapper").html() + '</div><div class="p-tools"><a href="' + t + '" class="btn btn-primary">Detail</a></div></div></div></div><span class="no-display" data-micro="sku">' + $("#product-detail-form meta[itemprop='sku']").attr("content") + "</span></div>";
            else
                a = '<div class="p" data-micro="product"><a href="' + t + '" class="image">' + $(".p-main-image").html() + '</a><div class="p-in"><div class="p-in-in"><a href="' + t + '" class="name" data-micro="url"><span data-micro="name">' + $(".p-detail-inner-header h1").text() + '</span> </a><div class="ratings-wrapper"><div class="stars-wrapper"></div><div class="availability"></div></div></div><div class="p-bottom"><div data-micro="offer" data-micro-price-currency="CZK" data-micro-warranty="2 roky"><div class="prices">' + $(".p-final-price-wrapper").html() + '</div><div class="p-tools"><form action="/action/Cart/addCartItem/" method="post" class="pr-action"><input type="hidden" name="language" value="cs"><input type="hidden" name="priceId" value="' + $("#product-detail-form input[name='priceId']").attr("value") + '"><input type="hidden" name="productId" value="' + $("#product-detail-form input[name='productId']").attr("value") + '"><button type="submit" class="btn btn-cart add-to-cart-button"><span>Do košíku</span></button></form></div></div></div></div><span class="no-display" data-micro="sku">' + $("#product-detail-form meta[itemprop='sku']").attr("content") + "</span></div>";
            fav_local("products_fav", e, a, $(this).closest(".p-data-wrapper").find(".p-detail-inner-header h1").text().trim(), $(this).closest(".product").find("a.name").attr("href"), $(this).closest(".p-image-wrapper").find(".p-main-image").html(), $(this).closest(".p-detail-info").find(".flags.flags-default").html(), $(this).closest(".p-image").find(".flags.flags-extra").html()),
            $("header#header .favorite_icon .number").html(JSON.parse(localStorage.getItem("products_fav")).length)
        })), $(".type-detail").length) && compare("products_fav", $(this).closest(".p-detail-inner").find('.p-data-wrapper #product-detail-form meta[itemprop="sku"]').attr("content"), $(this).closest(".p-data-wrapper").find(".p-detail-inner-header h1").text().trim())
    })), $("." + favorite_url_class).length) {
        if (JSON.parse(localStorage.getItem("products_fav")))
            var mhArr = JSON.parse(localStorage.getItem("products_fav"));
        else
            mhArr = "";
        if (mhArr.length) {
            $('div[itemprop="about"]').after('<div id="products" class="fav-products products products-page products-block"></div>');
            for (i = 0; i < mhArr.length; i++)
                $(".fav-products").append('<div class="product">' + mhArr[i].complete + "</div>");
            $("body").on("click", ".btn_toggle", (function() {
                $(this).closest(".product").remove(),
                $("header#header .favorite_icon .number").html(JSON.parse(localStorage.getItem("products_fav")).length)
            }))
        }
    }
}*/



!function(e) {
    "use strict";
    "function" == typeof define && define.amd ? define(["jquery"], e) : "undefined" != typeof exports ? module.exports = e(require("jquery")) : e(jQuery)
}((function(e) {
    "use strict";
    var t = window.Slick || {};
    (t = function() {
        var t = 0;
        return function(a, i) {
            var n,
                o = this;
            o.defaults = {
                accessibility: !0,
                adaptiveHeight: !1,
                appendArrows: e(a),
                appendDots: e(a),
                arrows: !0,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
                autoplay: !1,
                autoplaySpeed: 3e3,
                centerMode: !1,
                centerPadding: "50px",
                cssEase: "ease",
                customPaging: function(t, a) {
                    return e('<button type="button" />').text(a + 1)
                },
                dots: !1,
                dotsClass: "slick-dots",
                draggable: !0,
                easing: "linear",
                edgeFriction: .35,
                fade: !1,
                focusOnSelect: !1,
                focusOnChange: !1,
                infinite: !0,
                initialSlide: 0,
                lazyLoad: "ondemand",
                mobileFirst: !1,
                pauseOnHover: !0,
                pauseOnFocus: !0,
                pauseOnDotsHover: !1,
                respondTo: "window",
                responsive: null,
                rows: 1,
                rtl: !1,
                slide: "",
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: !0,
                swipeToSlide: !1,
                touchMove: !0,
                touchThreshold: 5,
                useCSS: !0,
                useTransform: !0,
                variableWidth: !1,
                vertical: !1,
                verticalSwiping: !1,
                waitForAnimate: !0,
                zIndex: 1e3
            },
            o.initials = {
                animating: !1,
                dragging: !1,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: !1,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: !1,
                slideOffset: 0,
                swipeLeft: null,
                swiping: !1,
                $list: null,
                touchObject: {},
                transformsEnabled: !1,
                unslicked: !1
            },
            e.extend(o, o.initials),
            o.activeBreakpoint = null,
            o.animType = null,
            o.animProp = null,
            o.breakpoints = [],
            o.breakpointSettings = [],
            o.cssTransitions = !1,
            o.focussed = !1,
            o.interrupted = !1,
            o.hidden = "hidden",
            o.paused = !0,
            o.positionProp = null,
            o.respondTo = null,
            o.rowCount = 1,
            o.shouldClick = !0,
            o.$slider = e(a),
            o.$slidesCache = null,
            o.transformType = null,
            o.transitionType = null,
            o.visibilityChange = "visibilitychange",
            o.windowWidth = 0,
            o.windowTimer = null,
            n = e(a).data("slick") || {},
            o.options = e.extend({}, o.defaults, i, n),
            o.currentSlide = o.options.initialSlide,
            o.originalSettings = o.options,
            void 0 !== document.mozHidden ? (o.hidden = "mozHidden", o.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (o.hidden = "webkitHidden", o.visibilityChange = "webkitvisibilitychange"),
            o.autoPlay = e.proxy(o.autoPlay, o),
            o.autoPlayClear = e.proxy(o.autoPlayClear, o),
            o.autoPlayIterator = e.proxy(o.autoPlayIterator, o),
            o.changeSlide = e.proxy(o.changeSlide, o),
            o.clickHandler = e.proxy(o.clickHandler, o),
            o.selectHandler = e.proxy(o.selectHandler, o),
            o.setPosition = e.proxy(o.setPosition, o),
            o.swipeHandler = e.proxy(o.swipeHandler, o),
            o.dragHandler = e.proxy(o.dragHandler, o),
            o.keyHandler = e.proxy(o.keyHandler, o),
            o.instanceUid = t++,
            o.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/,
            o.registerBreakpoints(),
            o.init(!0)
        }
    }()).prototype.activateADA = function() {
        this.$slideTrack.find(".slick-active").attr({
            "aria-hidden": "false"
        }).find("a, input, button, select").attr({
            tabindex: "0"
        })
    },
    t.prototype.addSlide = t.prototype.slickAdd = function(t, a, i) {
        var n = this;
        if ("boolean" == typeof a)
            i = a,
            a = null;
        else if (a < 0 || a >= n.slideCount)
            return !1;
        n.unload(),
        "number" == typeof a ? 0 === a && 0 === n.$slides.length ? e(t).appendTo(n.$slideTrack) : i ? e(t).insertBefore(n.$slides.eq(a)) : e(t).insertAfter(n.$slides.eq(a)) : !0 === i ? e(t).prependTo(n.$slideTrack) : e(t).appendTo(n.$slideTrack),
        n.$slides = n.$slideTrack.children(this.options.slide),
        n.$slideTrack.children(this.options.slide).detach(),
        n.$slideTrack.append(n.$slides),
        n.$slides.each((function(t, a) {
            e(a).attr("data-slick-index", t)
        })),
        n.$slidesCache = n.$slides,
        n.reinit()
    },
    t.prototype.animateHeight = function() {
        var e = this;
        if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.animate({
                height: t
            }, e.options.speed)
        }
    },
    t.prototype.animateSlide = function(t, a) {
        var i = {},
            n = this;
        n.animateHeight(),
        !0 === n.options.rtl && !1 === n.options.vertical && (t = -t),
        !1 === n.transformsEnabled ? !1 === n.options.vertical ? n.$slideTrack.animate({
            left: t
        }, n.options.speed, n.options.easing, a) : n.$slideTrack.animate({
            top: t
        }, n.options.speed, n.options.easing, a) : !1 === n.cssTransitions ? (!0 === n.options.rtl && (n.currentLeft = -n.currentLeft), e({
            animStart: n.currentLeft
        }).animate({
            animStart: t
        }, {
            duration: n.options.speed,
            easing: n.options.easing,
            step: function(e) {
                e = Math.ceil(e),
                !1 === n.options.vertical ? (i[n.animType] = "translate(" + e + "px, 0px)", n.$slideTrack.css(i)) : (i[n.animType] = "translate(0px," + e + "px)", n.$slideTrack.css(i))
            },
            complete: function() {
                a && a.call()
            }
        })) : (n.applyTransition(), t = Math.ceil(t), !1 === n.options.vertical ? i[n.animType] = "translate3d(" + t + "px, 0px, 0px)" : i[n.animType] = "translate3d(0px," + t + "px, 0px)", n.$slideTrack.css(i), a && setTimeout((function() {
            n.disableTransition(),
            a.call()
        }), n.options.speed))
    },
    t.prototype.getNavTarget = function() {
        var t = this.options.asNavFor;
        return t && null !== t && (t = e(t).not(this.$slider)), t
    },
    t.prototype.asNavFor = function(t) {
        var a = this.getNavTarget();
        null !== a && "object" == typeof a && a.each((function() {
            var a = e(this).slick("getSlick");
            a.unslicked || a.slideHandler(t, !0)
        }))
    },
    t.prototype.applyTransition = function(e) {
        var t = this,
            a = {};
        !1 === t.options.fade ? a[t.transitionType] = t.transformType + " " + t.options.speed + "ms " + t.options.cssEase : a[t.transitionType] = "opacity " + t.options.speed + "ms " + t.options.cssEase,
        !1 === t.options.fade ? t.$slideTrack.css(a) : t.$slides.eq(e).css(a)
    },
    t.prototype.autoPlay = function() {
        var e = this;
        e.autoPlayClear(),
        e.slideCount > e.options.slidesToShow && (e.autoPlayTimer = setInterval(e.autoPlayIterator, e.options.autoplaySpeed))
    },
    t.prototype.autoPlayClear = function() {
        this.autoPlayTimer && clearInterval(this.autoPlayTimer)
    },
    t.prototype.autoPlayIterator = function() {
        var e = this,
            t = e.currentSlide + e.options.slidesToScroll;
        e.paused || e.interrupted || e.focussed || (!1 === e.options.infinite && (1 === e.direction && e.currentSlide + 1 === e.slideCount - 1 ? e.direction = 0 : 0 === e.direction && (t = e.currentSlide - e.options.slidesToScroll, e.currentSlide - 1 == 0 && (e.direction = 1))), e.slideHandler(t))
    },
    t.prototype.buildArrows = function() {
        var t = this;
        !0 === t.options.arrows && (t.$prevArrow = e(t.options.prevArrow).addClass("slick-arrow"), t.$nextArrow = e(t.options.nextArrow).addClass("slick-arrow"), t.slideCount > t.options.slidesToShow ? (t.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.prependTo(t.options.appendArrows), t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.appendTo(t.options.appendArrows), !0 !== t.options.infinite && t.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : t.$prevArrow.add(t.$nextArrow).addClass("slick-hidden").attr({
            "aria-disabled": "true",
            tabindex: "-1"
        }))
    },
    t.prototype.buildDots = function() {
        var t,
            a,
            i = this;
        if (!0 === i.options.dots) {
            for (i.$slider.addClass("slick-dotted"), a = e("<ul />").addClass(i.options.dotsClass), t = 0; t <= i.getDotCount(); t += 1)
                a.append(e("<li />").append(i.options.customPaging.call(this, i, t)));
            i.$dots = a.appendTo(i.options.appendDots),
            i.$dots.find("li").first().addClass("slick-active")
        }
    },
    t.prototype.buildOut = function() {
        var t = this;
        t.$slides = t.$slider.children(t.options.slide + ":not(.slick-cloned)").addClass("slick-slide"),
        t.slideCount = t.$slides.length,
        t.$slides.each((function(t, a) {
            e(a).attr("data-slick-index", t).data("originalStyling", e(a).attr("style") || "")
        })),
        t.$slider.addClass("slick-slider"),
        t.$slideTrack = 0 === t.slideCount ? e('<div class="slick-track"/>').appendTo(t.$slider) : t.$slides.wrapAll('<div class="slick-track"/>').parent(),
        t.$list = t.$slideTrack.wrap('<div class="slick-list"/>').parent(),
        t.$slideTrack.css("opacity", 0),
        !0 !== t.options.centerMode && !0 !== t.options.swipeToSlide || (t.options.slidesToScroll = 1),
        e("img[data-lazy]", t.$slider).not("[src]").addClass("slick-loading"),
        t.setupInfinite(),
        t.buildArrows(),
        t.buildDots(),
        t.updateDots(),
        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
        !0 === t.options.draggable && t.$list.addClass("draggable")
    },
    t.prototype.buildRows = function() {
        var e,
            t,
            a,
            i,
            n,
            o,
            r,
            s = this;
        if (i = document.createDocumentFragment(), o = s.$slider.children(), s.options.rows > 1) {
            for (r = s.options.slidesPerRow * s.options.rows, n = Math.ceil(o.length / r), e = 0; e < n; e++) {
                var l = document.createElement("div");
                for (t = 0; t < s.options.rows; t++) {
                    var d = document.createElement("div");
                    for (a = 0; a < s.options.slidesPerRow; a++) {
                        var c = e * r + (t * s.options.slidesPerRow + a);
                        o.get(c) && d.appendChild(o.get(c))
                    }
                    l.appendChild(d)
                }
                i.appendChild(l)
            }
            s.$slider.empty().append(i),
            s.$slider.children().children().children().css({
                width: 100 / s.options.slidesPerRow + "%",
                display: "inline-block"
            })
        }
    },
    t.prototype.checkResponsive = function(t, a) {
        var i,
            n,
            o,
            r = this,
            s = !1,
            l = r.$slider.width(),
            d = window.innerWidth || e(window).width();
        if ("window" === r.respondTo ? o = d : "slider" === r.respondTo ? o = l : "min" === r.respondTo && (o = Math.min(d, l)), r.options.responsive && r.options.responsive.length && null !== r.options.responsive) {
            for (i in n = null, r.breakpoints)
                r.breakpoints.hasOwnProperty(i) && (!1 === r.originalSettings.mobileFirst ? o < r.breakpoints[i] && (n = r.breakpoints[i]) : o > r.breakpoints[i] && (n = r.breakpoints[i]));
            null !== n ? null !== r.activeBreakpoint ? (n !== r.activeBreakpoint || a) && (r.activeBreakpoint = n, "unslick" === r.breakpointSettings[n] ? r.unslick(n) : (r.options = e.extend({}, r.originalSettings, r.breakpointSettings[n]), !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t)), s = n) : (r.activeBreakpoint = n, "unslick" === r.breakpointSettings[n] ? r.unslick(n) : (r.options = e.extend({}, r.originalSettings, r.breakpointSettings[n]), !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t)), s = n) : null !== r.activeBreakpoint && (r.activeBreakpoint = null, r.options = r.originalSettings, !0 === t && (r.currentSlide = r.options.initialSlide), r.refresh(t), s = n),
            t || !1 === s || r.$slider.trigger("breakpoint", [r, s])
        }
    },
    t.prototype.changeSlide = function(t, a) {
        var i,
            n,
            o = this,
            r = e(t.currentTarget);
        switch (r.is("a") && t.preventDefault(), r.is("li") || (r = r.closest("li")), i = o.slideCount % o.options.slidesToScroll != 0 ? 0 : (o.slideCount - o.currentSlide) % o.options.slidesToScroll, t.data.message) {
        case "previous":
            n = 0 === i ? o.options.slidesToScroll : o.options.slidesToShow - i,
            o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide - n, !1, a);
            break;
        case "next":
            n = 0 === i ? o.options.slidesToScroll : i,
            o.slideCount > o.options.slidesToShow && o.slideHandler(o.currentSlide + n, !1, a);
            break;
        case "index":
            var s = 0 === t.data.index ? 0 : t.data.index || r.index() * o.options.slidesToScroll;
            o.slideHandler(o.checkNavigable(s), !1, a),
            r.children().trigger("focus");
            break;
        default:
            return
        }
    },
    t.prototype.checkNavigable = function(e) {
        var t,
            a;
        if (a = 0, e > (t = this.getNavigableIndexes())[t.length - 1])
            e = t[t.length - 1];
        else
            for (var i in t) {
                if (e < t[i]) {
                    e = a;
                    break
                }
                a = t[i]
            }
        return e
    },
    t.prototype.cleanUpEvents = function() {
        var t = this;
        t.options.dots && null !== t.$dots && (e("li", t.$dots).off("click.slick", t.changeSlide).off("mouseenter.slick", e.proxy(t.interrupt, t, !0)).off("mouseleave.slick", e.proxy(t.interrupt, t, !1)), !0 === t.options.accessibility && t.$dots.off("keydown.slick", t.keyHandler)),
        t.$slider.off("focus.slick blur.slick"),
        !0 === t.options.arrows && t.slideCount > t.options.slidesToShow && (t.$prevArrow && t.$prevArrow.off("click.slick", t.changeSlide), t.$nextArrow && t.$nextArrow.off("click.slick", t.changeSlide), !0 === t.options.accessibility && (t.$prevArrow && t.$prevArrow.off("keydown.slick", t.keyHandler), t.$nextArrow && t.$nextArrow.off("keydown.slick", t.keyHandler))),
        t.$list.off("touchstart.slick mousedown.slick", t.swipeHandler),
        t.$list.off("touchmove.slick mousemove.slick", t.swipeHandler),
        t.$list.off("touchend.slick mouseup.slick", t.swipeHandler),
        t.$list.off("touchcancel.slick mouseleave.slick", t.swipeHandler),
        t.$list.off("click.slick", t.clickHandler),
        e(document).off(t.visibilityChange, t.visibility),
        t.cleanUpSlideEvents(),
        !0 === t.options.accessibility && t.$list.off("keydown.slick", t.keyHandler),
        !0 === t.options.focusOnSelect && e(t.$slideTrack).children().off("click.slick", t.selectHandler),
        e(window).off("orientationchange.slick.slick-" + t.instanceUid, t.orientationChange),
        e(window).off("resize.slick.slick-" + t.instanceUid, t.resize),
        e("[draggable!=true]", t.$slideTrack).off("dragstart", t.preventDefault),
        e(window).off("load.slick.slick-" + t.instanceUid, t.setPosition)
    },
    t.prototype.cleanUpSlideEvents = function() {
        var t = this;
        t.$list.off("mouseenter.slick", e.proxy(t.interrupt, t, !0)),
        t.$list.off("mouseleave.slick", e.proxy(t.interrupt, t, !1))
    },
    t.prototype.cleanUpRows = function() {
        var e,
            t = this;
        t.options.rows > 1 && ((e = t.$slides.children().children()).removeAttr("style"), t.$slider.empty().append(e))
    },
    t.prototype.clickHandler = function(e) {
        !1 === this.shouldClick && (e.stopImmediatePropagation(), e.stopPropagation(), e.preventDefault())
    },
    t.prototype.destroy = function(t) {
        var a = this;
        a.autoPlayClear(),
        a.touchObject = {},
        a.cleanUpEvents(),
        e(".slick-cloned", a.$slider).detach(),
        a.$dots && a.$dots.remove(),
        a.$prevArrow && a.$prevArrow.length && (a.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), a.htmlExpr.test(a.options.prevArrow) && a.$prevArrow.remove()),
        a.$nextArrow && a.$nextArrow.length && (a.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), a.htmlExpr.test(a.options.nextArrow) && a.$nextArrow.remove()),
        a.$slides && (a.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each((function() {
            e(this).attr("style", e(this).data("originalStyling"))
        })), a.$slideTrack.children(this.options.slide).detach(), a.$slideTrack.detach(), a.$list.detach(), a.$slider.append(a.$slides)),
        a.cleanUpRows(),
        a.$slider.removeClass("slick-slider"),
        a.$slider.removeClass("slick-initialized"),
        a.$slider.removeClass("slick-dotted"),
        a.unslicked = !0,
        t || a.$slider.trigger("destroy", [a])
    },
    t.prototype.disableTransition = function(e) {
        var t = this,
            a = {};
        a[t.transitionType] = "",
        !1 === t.options.fade ? t.$slideTrack.css(a) : t.$slides.eq(e).css(a)
    },
    t.prototype.fadeSlide = function(e, t) {
        var a = this;
        !1 === a.cssTransitions ? (a.$slides.eq(e).css({
            zIndex: a.options.zIndex
        }), a.$slides.eq(e).animate({
            opacity: 1
        }, a.options.speed, a.options.easing, t)) : (a.applyTransition(e), a.$slides.eq(e).css({
            opacity: 1,
            zIndex: a.options.zIndex
        }), t && setTimeout((function() {
            a.disableTransition(e),
            t.call()
        }), a.options.speed))
    },
    t.prototype.fadeSlideOut = function(e) {
        var t = this;
        !1 === t.cssTransitions ? t.$slides.eq(e).animate({
            opacity: 0,
            zIndex: t.options.zIndex - 2
        }, t.options.speed, t.options.easing) : (t.applyTransition(e), t.$slides.eq(e).css({
            opacity: 0,
            zIndex: t.options.zIndex - 2
        }))
    },
    t.prototype.filterSlides = t.prototype.slickFilter = function(e) {
        var t = this;
        null !== e && (t.$slidesCache = t.$slides, t.unload(), t.$slideTrack.children(this.options.slide).detach(), t.$slidesCache.filter(e).appendTo(t.$slideTrack), t.reinit())
    },
    t.prototype.focusHandler = function() {
        var t = this;
        t.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick", "*", (function(a) {
            a.stopImmediatePropagation();
            var i = e(this);
            setTimeout((function() {
                t.options.pauseOnFocus && (t.focussed = i.is(":focus"), t.autoPlay())
            }), 0)
        }))
    },
    t.prototype.getCurrent = t.prototype.slickCurrentSlide = function() {
        return this.currentSlide
    },
    t.prototype.getDotCount = function() {
        var e = this,
            t = 0,
            a = 0,
            i = 0;
        if (!0 === e.options.infinite)
            if (e.slideCount <= e.options.slidesToShow)
                ++i;
            else
                for (; t < e.slideCount;)
                    ++i,
                    t = a + e.options.slidesToScroll,
                    a += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        else if (!0 === e.options.centerMode)
            i = e.slideCount;
        else if (e.options.asNavFor)
            for (; t < e.slideCount;)
                ++i,
                t = a + e.options.slidesToScroll,
                a += e.options.slidesToScroll <= e.options.slidesToShow ? e.options.slidesToScroll : e.options.slidesToShow;
        else
            i = 1 + Math.ceil((e.slideCount - e.options.slidesToShow) / e.options.slidesToScroll);
        return i - 1
    },
    t.prototype.getLeft = function(e) {
        var t,
            a,
            i,
            n,
            o = this,
            r = 0;
        return o.slideOffset = 0, a = o.$slides.first().outerHeight(!0), !0 === o.options.infinite ? (o.slideCount > o.options.slidesToShow && (o.slideOffset = o.slideWidth * o.options.slidesToShow * -1, n = -1, !0 === o.options.vertical && !0 === o.options.centerMode && (2 === o.options.slidesToShow ? n = -1.5 : 1 === o.options.slidesToShow && (n = -2)), r = a * o.options.slidesToShow * n), o.slideCount % o.options.slidesToScroll != 0 && e + o.options.slidesToScroll > o.slideCount && o.slideCount > o.options.slidesToShow && (e > o.slideCount ? (o.slideOffset = (o.options.slidesToShow - (e - o.slideCount)) * o.slideWidth * -1, r = (o.options.slidesToShow - (e - o.slideCount)) * a * -1) : (o.slideOffset = o.slideCount % o.options.slidesToScroll * o.slideWidth * -1, r = o.slideCount % o.options.slidesToScroll * a * -1))) : e + o.options.slidesToShow > o.slideCount && (o.slideOffset = (e + o.options.slidesToShow - o.slideCount) * o.slideWidth, r = (e + o.options.slidesToShow - o.slideCount) * a), o.slideCount <= o.options.slidesToShow && (o.slideOffset = 0, r = 0), !0 === o.options.centerMode && o.slideCount <= o.options.slidesToShow ? o.slideOffset = o.slideWidth * Math.floor(o.options.slidesToShow) / 2 - o.slideWidth * o.slideCount / 2 : !0 === o.options.centerMode && !0 === o.options.infinite ? o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2) - o.slideWidth : !0 === o.options.centerMode && (o.slideOffset = 0, o.slideOffset += o.slideWidth * Math.floor(o.options.slidesToShow / 2)), t = !1 === o.options.vertical ? e * o.slideWidth * -1 + o.slideOffset : e * a * -1 + r, !0 === o.options.variableWidth && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow), t = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, !0 === o.options.centerMode && (i = o.slideCount <= o.options.slidesToShow || !1 === o.options.infinite ? o.$slideTrack.children(".slick-slide").eq(e) : o.$slideTrack.children(".slick-slide").eq(e + o.options.slidesToShow + 1), t = !0 === o.options.rtl ? i[0] ? -1 * (o.$slideTrack.width() - i[0].offsetLeft - i.width()) : 0 : i[0] ? -1 * i[0].offsetLeft : 0, t += (o.$list.width() - i.outerWidth()) / 2)), t
    },
    t.prototype.getOption = t.prototype.slickGetOption = function(e) {
        return this.options[e]
    },
    t.prototype.getNavigableIndexes = function() {
        var e,
            t = this,
            a = 0,
            i = 0,
            n = [];
        for (!1 === t.options.infinite ? e = t.slideCount : (a = -1 * t.options.slidesToScroll, i = -1 * t.options.slidesToScroll, e = 2 * t.slideCount); a < e;)
            n.push(a),
            a = i + t.options.slidesToScroll,
            i += t.options.slidesToScroll <= t.options.slidesToShow ? t.options.slidesToScroll : t.options.slidesToShow;
        return n
    },
    t.prototype.getSlick = function() {
        return this
    },
    t.prototype.getSlideCount = function() {
        var t,
            a,
            i = this;
        return a = !0 === i.options.centerMode ? i.slideWidth * Math.floor(i.options.slidesToShow / 2) : 0, !0 === i.options.swipeToSlide ? (i.$slideTrack.find(".slick-slide").each((function(n, o) {
            if (o.offsetLeft - a + e(o).outerWidth() / 2 > -1 * i.swipeLeft)
                return t = o, !1
        })), Math.abs(e(t).attr("data-slick-index") - i.currentSlide) || 1) : i.options.slidesToScroll
    },
    t.prototype.goTo = t.prototype.slickGoTo = function(e, t) {
        this.changeSlide({
            data: {
                message: "index",
                index: parseInt(e)
            }
        }, t)
    },
    t.prototype.init = function(t) {
        var a = this;
        e(a.$slider).hasClass("slick-initialized") || (e(a.$slider).addClass("slick-initialized"), a.buildRows(), a.buildOut(), a.setProps(), a.startLoad(), a.loadSlider(), a.initializeEvents(), a.updateArrows(), a.updateDots(), a.checkResponsive(!0), a.focusHandler()),
        t && a.$slider.trigger("init", [a]),
        !0 === a.options.accessibility && a.initADA(),
        a.options.autoplay && (a.paused = !1, a.autoPlay())
    },
    t.prototype.initADA = function() {
        var t = this,
            a = Math.ceil(t.slideCount / t.options.slidesToShow),
            i = t.getNavigableIndexes().filter((function(e) {
                return e >= 0 && e < t.slideCount
            }));
        t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
            "aria-hidden": "true",
            tabindex: "-1"
        }).find("a, input, button, select").attr({
            tabindex: "-1"
        }),
        null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each((function(a) {
            var n = i.indexOf(a);
            e(this).attr({
                role: "tabpanel",
                id: "slick-slide" + t.instanceUid + a,
                tabindex: -1
            }),
            -1 !== n && e(this).attr({
                "aria-describedby": "slick-slide-control" + t.instanceUid + n
            })
        })), t.$dots.attr("role", "tablist").find("li").each((function(n) {
            var o = i[n];
            e(this).attr({
                role: "presentation"
            }),
            e(this).find("button").first().attr({
                role: "tab",
                id: "slick-slide-control" + t.instanceUid + n,
                "aria-controls": "slick-slide" + t.instanceUid + o,
                "aria-label": n + 1 + " of " + a,
                "aria-selected": null,
                tabindex: "-1"
            })
        })).eq(t.currentSlide).find("button").attr({
            "aria-selected": "true",
            tabindex: "0"
        }).end());
        for (var n = t.currentSlide, o = n + t.options.slidesToShow; n < o; n++)
            t.$slides.eq(n).attr("tabindex", 0);
        t.activateADA()
    },
    t.prototype.initArrowEvents = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.off("click.slick").on("click.slick", {
            message: "previous"
        }, e.changeSlide), e.$nextArrow.off("click.slick").on("click.slick", {
            message: "next"
        }, e.changeSlide), !0 === e.options.accessibility && (e.$prevArrow.on("keydown.slick", e.keyHandler), e.$nextArrow.on("keydown.slick", e.keyHandler)))
    },
    t.prototype.initDotEvents = function() {
        var t = this;
        !0 === t.options.dots && (e("li", t.$dots).on("click.slick", {
            message: "index"
        }, t.changeSlide), !0 === t.options.accessibility && t.$dots.on("keydown.slick", t.keyHandler)),
        !0 === t.options.dots && !0 === t.options.pauseOnDotsHover && e("li", t.$dots).on("mouseenter.slick", e.proxy(t.interrupt, t, !0)).on("mouseleave.slick", e.proxy(t.interrupt, t, !1))
    },
    t.prototype.initSlideEvents = function() {
        var t = this;
        t.options.pauseOnHover && (t.$list.on("mouseenter.slick", e.proxy(t.interrupt, t, !0)), t.$list.on("mouseleave.slick", e.proxy(t.interrupt, t, !1)))
    },
    t.prototype.initializeEvents = function() {
        var t = this;
        t.initArrowEvents(),
        t.initDotEvents(),
        t.initSlideEvents(),
        t.$list.on("touchstart.slick mousedown.slick", {
            action: "start"
        }, t.swipeHandler),
        t.$list.on("touchmove.slick mousemove.slick", {
            action: "move"
        }, t.swipeHandler),
        t.$list.on("touchend.slick mouseup.slick", {
            action: "end"
        }, t.swipeHandler),
        t.$list.on("touchcancel.slick mouseleave.slick", {
            action: "end"
        }, t.swipeHandler),
        t.$list.on("click.slick", t.clickHandler),
        e(document).on(t.visibilityChange, e.proxy(t.visibility, t)),
        !0 === t.options.accessibility && t.$list.on("keydown.slick", t.keyHandler),
        !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
        e(window).on("orientationchange.slick.slick-" + t.instanceUid, e.proxy(t.orientationChange, t)),
        e(window).on("resize.slick.slick-" + t.instanceUid, e.proxy(t.resize, t)),
        e("[draggable!=true]", t.$slideTrack).on("dragstart", t.preventDefault),
        e(window).on("load.slick.slick-" + t.instanceUid, t.setPosition),
        e(t.setPosition)
    },
    t.prototype.initUI = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.show(), e.$nextArrow.show()),
        !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.show()
    },
    t.prototype.keyHandler = function(e) {
        var t = this;
        e.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === e.keyCode && !0 === t.options.accessibility ? t.changeSlide({
            data: {
                message: !0 === t.options.rtl ? "next" : "previous"
            }
        }) : 39 === e.keyCode && !0 === t.options.accessibility && t.changeSlide({
            data: {
                message: !0 === t.options.rtl ? "previous" : "next"
            }
        }))
    },
    t.prototype.lazyLoad = function() {
        function t(t) {
            e("img[data-lazy]", t).each((function() {
                var t = e(this),
                    a = e(this).attr("data-lazy"),
                    i = e(this).attr("data-srcset"),
                    n = e(this).attr("data-sizes") || o.$slider.attr("data-sizes"),
                    r = document.createElement("img");
                r.onload = function() {
                    t.animate({
                        opacity: 0
                    }, 100, (function() {
                        i && (t.attr("srcset", i), n && t.attr("sizes", n)),
                        t.attr("src", a).animate({
                            opacity: 1
                        }, 200, (function() {
                            t.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
                        })),
                        o.$slider.trigger("lazyLoaded", [o, t, a])
                    }))
                },
                r.onerror = function() {
                    t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),
                    o.$slider.trigger("lazyLoadError", [o, t, a])
                },
                r.src = a
            }))
        }
        var a,
            i,
            n,
            o = this;
        if (!0 === o.options.centerMode ? !0 === o.options.infinite ? n = (i = o.currentSlide + (o.options.slidesToShow / 2 + 1)) + o.options.slidesToShow + 2 : (i = Math.max(0, o.currentSlide - (o.options.slidesToShow / 2 + 1)), n = o.options.slidesToShow / 2 + 1 + 2 + o.currentSlide) : (i = o.options.infinite ? o.options.slidesToShow + o.currentSlide : o.currentSlide, n = Math.ceil(i + o.options.slidesToShow), !0 === o.options.fade && (i > 0 && i--, n <= o.slideCount && n++)), a = o.$slider.find(".slick-slide").slice(i, n), "anticipated" === o.options.lazyLoad)
            for (var r = i - 1, s = n, l = o.$slider.find(".slick-slide"), d = 0; d < o.options.slidesToScroll; d++)
                r < 0 && (r = o.slideCount - 1),
                a = (a = a.add(l.eq(r))).add(l.eq(s)),
                r--,
                s++;
        t(a),
        o.slideCount <= o.options.slidesToShow ? t(o.$slider.find(".slick-slide")) : o.currentSlide >= o.slideCount - o.options.slidesToShow ? t(o.$slider.find(".slick-cloned").slice(0, o.options.slidesToShow)) : 0 === o.currentSlide && t(o.$slider.find(".slick-cloned").slice(-1 * o.options.slidesToShow))
    },
    t.prototype.loadSlider = function() {
        var e = this;
        e.setPosition(),
        e.$slideTrack.css({
            opacity: 1
        }),
        e.$slider.removeClass("slick-loading"),
        e.initUI(),
        "progressive" === e.options.lazyLoad && e.progressiveLazyLoad()
    },
    t.prototype.next = t.prototype.slickNext = function() {
        this.changeSlide({
            data: {
                message: "next"
            }
        })
    },
    t.prototype.orientationChange = function() {
        this.checkResponsive(),
        this.setPosition()
    },
    t.prototype.pause = t.prototype.slickPause = function() {
        this.autoPlayClear(),
        this.paused = !0
    },
    t.prototype.play = t.prototype.slickPlay = function() {
        var e = this;
        e.autoPlay(),
        e.options.autoplay = !0,
        e.paused = !1,
        e.focussed = !1,
        e.interrupted = !1
    },
    t.prototype.postSlide = function(t) {
        var a = this;
        a.unslicked || (a.$slider.trigger("afterChange", [a, t]), a.animating = !1, a.slideCount > a.options.slidesToShow && a.setPosition(), a.swipeLeft = null, a.options.autoplay && a.autoPlay(), !0 === a.options.accessibility && (a.initADA(), a.options.focusOnChange && e(a.$slides.get(a.currentSlide)).attr("tabindex", 0).focus()))
    },
    t.prototype.prev = t.prototype.slickPrev = function() {
        this.changeSlide({
            data: {
                message: "previous"
            }
        })
    },
    t.prototype.preventDefault = function(e) {
        e.preventDefault()
    },
    t.prototype.progressiveLazyLoad = function(t) {
        t = t || 1;
        var a,
            i,
            n,
            o,
            r,
            s = this,
            l = e("img[data-lazy]", s.$slider);
        l.length ? (a = l.first(), i = a.attr("data-lazy"), n = a.attr("data-srcset"), o = a.attr("data-sizes") || s.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function() {
            n && (a.attr("srcset", n), o && a.attr("sizes", o)),
            a.attr("src", i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),
            !0 === s.options.adaptiveHeight && s.setPosition(),
            s.$slider.trigger("lazyLoaded", [s, a, i]),
            s.progressiveLazyLoad()
        }, r.onerror = function() {
            t < 3 ? setTimeout((function() {
                s.progressiveLazyLoad(t + 1)
            }), 500) : (a.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), s.$slider.trigger("lazyLoadError", [s, a, i]), s.progressiveLazyLoad())
        }, r.src = i) : s.$slider.trigger("allImagesLoaded", [s])
    },
    t.prototype.refresh = function(t) {
        var a,
            i,
            n = this;
        i = n.slideCount - n.options.slidesToShow,
        !n.options.infinite && n.currentSlide > i && (n.currentSlide = i),
        n.slideCount <= n.options.slidesToShow && (n.currentSlide = 0),
        a = n.currentSlide,
        n.destroy(!0),
        e.extend(n, n.initials, {
            currentSlide: a
        }),
        n.init(),
        t || n.changeSlide({
            data: {
                message: "index",
                index: a
            }
        }, !1)
    },
    t.prototype.registerBreakpoints = function() {
        var t,
            a,
            i,
            n = this,
            o = n.options.responsive || null;
        if ("array" === e.type(o) && o.length) {
            for (t in n.respondTo = n.options.respondTo || "window", o)
                if (i = n.breakpoints.length - 1, o.hasOwnProperty(t)) {
                    for (a = o[t].breakpoint; i >= 0;)
                        n.breakpoints[i] && n.breakpoints[i] === a && n.breakpoints.splice(i, 1),
                        i--;
                    n.breakpoints.push(a),
                    n.breakpointSettings[a] = o[t].settings
                }
            n.breakpoints.sort((function(e, t) {
                return n.options.mobileFirst ? e - t : t - e
            }))
        }
    },
    t.prototype.reinit = function() {
        var t = this;
        t.$slides = t.$slideTrack.children(t.options.slide).addClass("slick-slide"),
        t.slideCount = t.$slides.length,
        t.currentSlide >= t.slideCount && 0 !== t.currentSlide && (t.currentSlide = t.currentSlide - t.options.slidesToScroll),
        t.slideCount <= t.options.slidesToShow && (t.currentSlide = 0),
        t.registerBreakpoints(),
        t.setProps(),
        t.setupInfinite(),
        t.buildArrows(),
        t.updateArrows(),
        t.initArrowEvents(),
        t.buildDots(),
        t.updateDots(),
        t.initDotEvents(),
        t.cleanUpSlideEvents(),
        t.initSlideEvents(),
        t.checkResponsive(!1, !0),
        !0 === t.options.focusOnSelect && e(t.$slideTrack).children().on("click.slick", t.selectHandler),
        t.setSlideClasses("number" == typeof t.currentSlide ? t.currentSlide : 0),
        t.setPosition(),
        t.focusHandler(),
        t.paused = !t.options.autoplay,
        t.autoPlay(),
        t.$slider.trigger("reInit", [t])
    },
    t.prototype.resize = function() {
        var t = this;
        e(window).width() !== t.windowWidth && (clearTimeout(t.windowDelay), t.windowDelay = window.setTimeout((function() {
            t.windowWidth = e(window).width(),
            t.checkResponsive(),
            t.unslicked || t.setPosition()
        }), 50))
    },
    t.prototype.removeSlide = t.prototype.slickRemove = function(e, t, a) {
        var i = this;
        if (e = "boolean" == typeof e ? !0 === (t = e) ? 0 : i.slideCount - 1 : !0 === t ? --e : e, i.slideCount < 1 || e < 0 || e > i.slideCount - 1)
            return !1;
        i.unload(),
        !0 === a ? i.$slideTrack.children().remove() : i.$slideTrack.children(this.options.slide).eq(e).remove(),
        i.$slides = i.$slideTrack.children(this.options.slide),
        i.$slideTrack.children(this.options.slide).detach(),
        i.$slideTrack.append(i.$slides),
        i.$slidesCache = i.$slides,
        i.reinit()
    },
    t.prototype.setCSS = function(e) {
        var t,
            a,
            i = this,
            n = {};
        !0 === i.options.rtl && (e = -e),
        t = "left" == i.positionProp ? Math.ceil(e) + "px" : "0px",
        a = "top" == i.positionProp ? Math.ceil(e) + "px" : "0px",
        n[i.positionProp] = e,
        !1 === i.transformsEnabled ? i.$slideTrack.css(n) : (n = {}, !1 === i.cssTransitions ? (n[i.animType] = "translate(" + t + ", " + a + ")", i.$slideTrack.css(n)) : (n[i.animType] = "translate3d(" + t + ", " + a + ", 0px)", i.$slideTrack.css(n)))
    },
    t.prototype.setDimensions = function() {
        var e = this;
        !1 === e.options.vertical ? !0 === e.options.centerMode && e.$list.css({
            padding: "0px " + e.options.centerPadding
        }) : (e.$list.height(e.$slides.first().outerHeight(!0) * e.options.slidesToShow), !0 === e.options.centerMode && e.$list.css({
            padding: e.options.centerPadding + " 0px"
        })),
        e.listWidth = e.$list.width(),
        e.listHeight = e.$list.height(),
        !1 === e.options.vertical && !1 === e.options.variableWidth ? (e.slideWidth = Math.ceil(e.listWidth / e.options.slidesToShow), e.$slideTrack.width(Math.ceil(e.slideWidth * e.$slideTrack.children(".slick-slide").length))) : !0 === e.options.variableWidth ? e.$slideTrack.width(5e3 * e.slideCount) : (e.slideWidth = Math.ceil(e.listWidth), e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0) * e.$slideTrack.children(".slick-slide").length)));
        var t = e.$slides.first().outerWidth(!0) - e.$slides.first().width();
        !1 === e.options.variableWidth && e.$slideTrack.children(".slick-slide").width(e.slideWidth - t)
    },
    t.prototype.setFade = function() {
        var t,
            a = this;
        a.$slides.each((function(i, n) {
            t = a.slideWidth * i * -1,
            !0 === a.options.rtl ? e(n).css({
                position: "relative",
                right: t,
                top: 0,
                zIndex: a.options.zIndex - 2,
                opacity: 0
            }) : e(n).css({
                position: "relative",
                left: t,
                top: 0,
                zIndex: a.options.zIndex - 2,
                opacity: 0
            })
        })),
        a.$slides.eq(a.currentSlide).css({
            zIndex: a.options.zIndex - 1,
            opacity: 1
        })
    },
    t.prototype.setHeight = function() {
        var e = this;
        if (1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical) {
            var t = e.$slides.eq(e.currentSlide).outerHeight(!0);
            e.$list.css("height", t)
        }
    },
    t.prototype.setOption = t.prototype.slickSetOption = function() {
        var t,
            a,
            i,
            n,
            o,
            r = this,
            s = !1;
        if ("object" === e.type(arguments[0]) ? (i = arguments[0], s = arguments[1], o = "multiple") : "string" === e.type(arguments[0]) && (i = arguments[0], n = arguments[1], s = arguments[2], "responsive" === arguments[0] && "array" === e.type(arguments[1]) ? o = "responsive" : void 0 !== arguments[1] && (o = "single")), "single" === o)
            r.options[i] = n;
        else if ("multiple" === o)
            e.each(i, (function(e, t) {
                r.options[e] = t
            }));
        else if ("responsive" === o)
            for (a in n)
                if ("array" !== e.type(r.options.responsive))
                    r.options.responsive = [n[a]];
                else {
                    for (t = r.options.responsive.length - 1; t >= 0;)
                        r.options.responsive[t].breakpoint === n[a].breakpoint && r.options.responsive.splice(t, 1),
                        t--;
                    r.options.responsive.push(n[a])
                }
        s && (r.unload(), r.reinit())
    },
    t.prototype.setPosition = function() {
        var e = this;
        e.setDimensions(),
        e.setHeight(),
        !1 === e.options.fade ? e.setCSS(e.getLeft(e.currentSlide)) : e.setFade(),
        e.$slider.trigger("setPosition", [e])
    },
    t.prototype.setProps = function() {
        var e = this,
            t = document.body.style;
        e.positionProp = !0 === e.options.vertical ? "top" : "left",
        "top" === e.positionProp ? e.$slider.addClass("slick-vertical") : e.$slider.removeClass("slick-vertical"),
        void 0 === t.WebkitTransition && void 0 === t.MozTransition && void 0 === t.msTransition || !0 === e.options.useCSS && (e.cssTransitions = !0),
        e.options.fade && ("number" == typeof e.options.zIndex ? e.options.zIndex < 3 && (e.options.zIndex = 3) : e.options.zIndex = e.defaults.zIndex),
        void 0 !== t.OTransform && (e.animType = "OTransform", e.transformType = "-o-transform", e.transitionType = "OTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
        void 0 !== t.MozTransform && (e.animType = "MozTransform", e.transformType = "-moz-transform", e.transitionType = "MozTransition", void 0 === t.perspectiveProperty && void 0 === t.MozPerspective && (e.animType = !1)),
        void 0 !== t.webkitTransform && (e.animType = "webkitTransform", e.transformType = "-webkit-transform", e.transitionType = "webkitTransition", void 0 === t.perspectiveProperty && void 0 === t.webkitPerspective && (e.animType = !1)),
        void 0 !== t.msTransform && (e.animType = "msTransform", e.transformType = "-ms-transform", e.transitionType = "msTransition", void 0 === t.msTransform && (e.animType = !1)),
        void 0 !== t.transform && !1 !== e.animType && (e.animType = "transform", e.transformType = "transform", e.transitionType = "transition"),
        e.transformsEnabled = e.options.useTransform && null !== e.animType && !1 !== e.animType
    },
    t.prototype.setSlideClasses = function(e) {
        var t,
            a,
            i,
            n,
            o = this;
        if (a = o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true"), o.$slides.eq(e).addClass("slick-current"), !0 === o.options.centerMode) {
            var r = o.options.slidesToShow % 2 == 0 ? 1 : 0;
            t = Math.floor(o.options.slidesToShow / 2),
            !0 === o.options.infinite && (e >= t && e <= o.slideCount - 1 - t ? o.$slides.slice(e - t + r, e + t + 1).addClass("slick-active").attr("aria-hidden", "false") : (i = o.options.slidesToShow + e, a.slice(i - t + 1 + r, i + t + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === e ? a.eq(a.length - 1 - o.options.slidesToShow).addClass("slick-center") : e === o.slideCount - 1 && a.eq(o.options.slidesToShow).addClass("slick-center")),
            o.$slides.eq(e).addClass("slick-center")
        } else
            e >= 0 && e <= o.slideCount - o.options.slidesToShow ? o.$slides.slice(e, e + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : a.length <= o.options.slidesToShow ? a.addClass("slick-active").attr("aria-hidden", "false") : (n = o.slideCount % o.options.slidesToShow, i = !0 === o.options.infinite ? o.options.slidesToShow + e : e, o.options.slidesToShow == o.options.slidesToScroll && o.slideCount - e < o.options.slidesToShow ? a.slice(i - (o.options.slidesToShow - n), i + n).addClass("slick-active").attr("aria-hidden", "false") : a.slice(i, i + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false"));
        "ondemand" !== o.options.lazyLoad && "anticipated" !== o.options.lazyLoad || o.lazyLoad()
    },
    t.prototype.setupInfinite = function() {
        var t,
            a,
            i,
            n = this;
        if (!0 === n.options.fade && (n.options.centerMode = !1), !0 === n.options.infinite && !1 === n.options.fade && (a = null, n.slideCount > n.options.slidesToShow)) {
            for (i = !0 === n.options.centerMode ? n.options.slidesToShow + 1 : n.options.slidesToShow, t = n.slideCount; t > n.slideCount - i; t -= 1)
                a = t - 1,
                e(n.$slides[a]).clone(!0).attr("id", "").attr("data-slick-index", a - n.slideCount).prependTo(n.$slideTrack).addClass("slick-cloned");
            for (t = 0; t < i + n.slideCount; t += 1)
                a = t,
                e(n.$slides[a]).clone(!0).attr("id", "").attr("data-slick-index", a + n.slideCount).appendTo(n.$slideTrack).addClass("slick-cloned");
            n.$slideTrack.find(".slick-cloned").find("[id]").each((function() {
                e(this).attr("id", "")
            }))
        }
    },
    t.prototype.interrupt = function(e) {
        e || this.autoPlay(),
        this.interrupted = e
    },
    t.prototype.selectHandler = function(t) {
        var a = this,
            i = e(t.target).is(".slick-slide") ? e(t.target) : e(t.target).parents(".slick-slide"),
            n = parseInt(i.attr("data-slick-index"));
        n || (n = 0),
        a.slideCount <= a.options.slidesToShow ? a.slideHandler(n, !1, !0) : a.slideHandler(n)
    },
    t.prototype.slideHandler = function(e, t, a) {
        var i,
            n,
            o,
            r,
            s,
            l = null,
            d = this;
        if (t = t || !1, !(!0 === d.animating && !0 === d.options.waitForAnimate || !0 === d.options.fade && d.currentSlide === e))
            if (!1 === t && d.asNavFor(e), i = e, l = d.getLeft(i), r = d.getLeft(d.currentSlide), d.currentLeft = null === d.swipeLeft ? r : d.swipeLeft, !1 === d.options.infinite && !1 === d.options.centerMode && (e < 0 || e > d.getDotCount() * d.options.slidesToScroll))
                !1 === d.options.fade && (i = d.currentSlide, !0 !== a ? d.animateSlide(r, (function() {
                    d.postSlide(i)
                })) : d.postSlide(i));
            else if (!1 === d.options.infinite && !0 === d.options.centerMode && (e < 0 || e > d.slideCount - d.options.slidesToScroll))
                !1 === d.options.fade && (i = d.currentSlide, !0 !== a ? d.animateSlide(r, (function() {
                    d.postSlide(i)
                })) : d.postSlide(i));
            else {
                if (d.options.autoplay && clearInterval(d.autoPlayTimer), n = i < 0 ? d.slideCount % d.options.slidesToScroll != 0 ? d.slideCount - d.slideCount % d.options.slidesToScroll : d.slideCount + i : i >= d.slideCount ? d.slideCount % d.options.slidesToScroll != 0 ? 0 : i - d.slideCount : i, d.animating = !0, d.$slider.trigger("beforeChange", [d, d.currentSlide, n]), o = d.currentSlide, d.currentSlide = n, d.setSlideClasses(d.currentSlide), d.options.asNavFor && (s = (s = d.getNavTarget()).slick("getSlick")).slideCount <= s.options.slidesToShow && s.setSlideClasses(d.currentSlide), d.updateDots(), d.updateArrows(), !0 === d.options.fade)
                    return !0 !== a ? (d.fadeSlideOut(o), d.fadeSlide(n, (function() {
                        d.postSlide(n)
                    }))) : d.postSlide(n), void d.animateHeight();
                !0 !== a ? d.animateSlide(l, (function() {
                    d.postSlide(n)
                })) : d.postSlide(n)
            }
    },
    t.prototype.startLoad = function() {
        var e = this;
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && (e.$prevArrow.hide(), e.$nextArrow.hide()),
        !0 === e.options.dots && e.slideCount > e.options.slidesToShow && e.$dots.hide(),
        e.$slider.addClass("slick-loading")
    },
    t.prototype.swipeDirection = function() {
        var e,
            t,
            a,
            i,
            n = this;
        return e = n.touchObject.startX - n.touchObject.curX, t = n.touchObject.startY - n.touchObject.curY, a = Math.atan2(t, e), (i = Math.round(180 * a / Math.PI)) < 0 && (i = 360 - Math.abs(i)), i <= 45 && i >= 0 || i <= 360 && i >= 315 ? !1 === n.options.rtl ? "left" : "right" : i >= 135 && i <= 225 ? !1 === n.options.rtl ? "right" : "left" : !0 === n.options.verticalSwiping ? i >= 35 && i <= 135 ? "down" : "up" : "vertical"
    },
    t.prototype.swipeEnd = function(e) {
        var t,
            a,
            i = this;
        if (i.dragging = !1, i.swiping = !1, i.scrolling)
            return i.scrolling = !1, !1;
        if (i.interrupted = !1, i.shouldClick = !(i.touchObject.swipeLength > 10), void 0 === i.touchObject.curX)
            return !1;
        if (!0 === i.touchObject.edgeHit && i.$slider.trigger("edge", [i, i.swipeDirection()]), i.touchObject.swipeLength >= i.touchObject.minSwipe) {
            switch (a = i.swipeDirection()) {
            case "left":
            case "down":
                t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide + i.getSlideCount()) : i.currentSlide + i.getSlideCount(),
                i.currentDirection = 0;
                break;
            case "right":
            case "up":
                t = i.options.swipeToSlide ? i.checkNavigable(i.currentSlide - i.getSlideCount()) : i.currentSlide - i.getSlideCount(),
                i.currentDirection = 1
            }
            "vertical" != a && (i.slideHandler(t), i.touchObject = {}, i.$slider.trigger("swipe", [i, a]))
        } else
            i.touchObject.startX !== i.touchObject.curX && (i.slideHandler(i.currentSlide), i.touchObject = {})
    },
    t.prototype.swipeHandler = function(e) {
        var t = this;
        if (!(!1 === t.options.swipe || "ontouchend" in document && !1 === t.options.swipe || !1 === t.options.draggable && -1 !== e.type.indexOf("mouse")))
            switch (t.touchObject.fingerCount = e.originalEvent && void 0 !== e.originalEvent.touches ? e.originalEvent.touches.length : 1, t.touchObject.minSwipe = t.listWidth / t.options.touchThreshold, !0 === t.options.verticalSwiping && (t.touchObject.minSwipe = t.listHeight / t.options.touchThreshold), e.data.action) {
            case "start":
                t.swipeStart(e);
                break;
            case "move":
                t.swipeMove(e);
                break;
            case "end":
                t.swipeEnd(e)
            }
    },
    t.prototype.swipeMove = function(e) {
        var t,
            a,
            i,
            n,
            o,
            r,
            s = this;
        return o = void 0 !== e.originalEvent ? e.originalEvent.touches : null, !(!s.dragging || s.scrolling || o && 1 !== o.length) && (t = s.getLeft(s.currentSlide), s.touchObject.curX = void 0 !== o ? o[0].pageX : e.clientX, s.touchObject.curY = void 0 !== o ? o[0].pageY : e.clientY, s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))), r = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2))), !s.options.verticalSwiping && !s.swiping && r > 4 ? (s.scrolling = !0, !1) : (!0 === s.options.verticalSwiping && (s.touchObject.swipeLength = r), a = s.swipeDirection(), void 0 !== e.originalEvent && s.touchObject.swipeLength > 4 && (s.swiping = !0, e.preventDefault()), n = (!1 === s.options.rtl ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1), !0 === s.options.verticalSwiping && (n = s.touchObject.curY > s.touchObject.startY ? 1 : -1), i = s.touchObject.swipeLength, s.touchObject.edgeHit = !1, !1 === s.options.infinite && (0 === s.currentSlide && "right" === a || s.currentSlide >= s.getDotCount() && "left" === a) && (i = s.touchObject.swipeLength * s.options.edgeFriction, s.touchObject.edgeHit = !0), !1 === s.options.vertical ? s.swipeLeft = t + i * n : s.swipeLeft = t + i * (s.$list.height() / s.listWidth) * n, !0 === s.options.verticalSwiping && (s.swipeLeft = t + i * n), !0 !== s.options.fade && !1 !== s.options.touchMove && (!0 === s.animating ? (s.swipeLeft = null, !1) : void s.setCSS(s.swipeLeft))))
    },
    t.prototype.swipeStart = function(e) {
        var t,
            a = this;
        if (a.interrupted = !0, 1 !== a.touchObject.fingerCount || a.slideCount <= a.options.slidesToShow)
            return a.touchObject = {}, !1;
        void 0 !== e.originalEvent && void 0 !== e.originalEvent.touches && (t = e.originalEvent.touches[0]),
        a.touchObject.startX = a.touchObject.curX = void 0 !== t ? t.pageX : e.clientX,
        a.touchObject.startY = a.touchObject.curY = void 0 !== t ? t.pageY : e.clientY,
        a.dragging = !0
    },
    t.prototype.unfilterSlides = t.prototype.slickUnfilter = function() {
        var e = this;
        null !== e.$slidesCache && (e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.appendTo(e.$slideTrack), e.reinit())
    },
    t.prototype.unload = function() {
        var t = this;
        e(".slick-cloned", t.$slider).remove(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow && t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove(),
        t.$nextArrow && t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove(),
        t.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
    },
    t.prototype.unslick = function(e) {
        var t = this;
        t.$slider.trigger("unslick", [t, e]),
        t.destroy()
    },
    t.prototype.updateArrows = function() {
        var e = this;
        Math.floor(e.options.slidesToShow / 2),
        !0 === e.options.arrows && e.slideCount > e.options.slidesToShow && !e.options.infinite && (e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === e.currentSlide ? (e.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (e.currentSlide >= e.slideCount - e.options.slidesToShow && !1 === e.options.centerMode || e.currentSlide >= e.slideCount - 1 && !0 === e.options.centerMode) && (e.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
    },
    t.prototype.updateDots = function() {
        var e = this;
        null !== e.$dots && (e.$dots.find("li").removeClass("slick-active").end(), e.$dots.find("li").eq(Math.floor(e.currentSlide / e.options.slidesToScroll)).addClass("slick-active"))
    },
    t.prototype.visibility = function() {
        var e = this;
        e.options.autoplay && (document[e.hidden] ? e.interrupted = !0 : e.interrupted = !1)
    },
    e.fn.slick = function() {
        var e,
            a,
            i = this,
            n = arguments[0],
            o = Array.prototype.slice.call(arguments, 1),
            r = i.length;
        for (e = 0; e < r; e++)
            if ("object" == typeof n || void 0 === n ? i[e].slick = new t(i[e], n) : a = i[e].slick[n].apply(i[e].slick, o), void 0 !== a)
                return a;
        return i
    }
}));
class MimeTranslation {
    static getString(e, t=null)
    {
        const a = e.split("."),
            i = t || this.getLocal();
        return this.getNestedTranslation(TRANS, a, i)
    }
    static getNestedTranslation(e, t, a)
    {
        let i = e;
        for (const e of t) {
            if (!i || !i[e])
                return "";
            i = i[e]
        }
        return i[a] || ""
    }
    static getLocal()
    {
        try {
            return document.querySelector("html").lang.toUpperCase()
        } catch (e) {
            return console.error(e), "CS"
        }
    }
}
function trans(e) {
    return MimeTranslation.getString(e)
}
const TRANS = {
    CATEGORY: {
        PEREX: {
            SHOWMORE: {
                CS: "Zobrazit více",
                SK: "Zobraziť viac"
            },
            SHOWLESS: {
                CS: "Zobrazit méně",
                SK: "Zobraziť menej"
            }
        }
    }
};
function mimeGetInfoByVariantID(e) {
    for (var t in shoptet.variantsSplit.necessaryVariantData)
        if (-1 !== t.indexOf(e))
            return shoptet.variantsSplit.necessaryVariantData[t];
    return null
}
if ($(".type-posts-listing.in-blog").length) {
    if ($(".content-inner>div").first().find('p img[alt*="- pozadí"]').length > 0 && ($(".content-inner>div").first().addClass("blog-background"), $(".content-inner>div").first().find('p img[alt*="- pozadí"]').hide(), $(".content-inner>div").first().attr("style", "background:url(" + $('.content-inner>div p img[alt*="- pozadí"]').attr("src") + ");background-size: cover;")), $('p:contains("#cely-popis#")').length) {
        $("body").addClass("blog-image-background"),
        $(".blog-background").append('<div class="dsc-bottom"></div>');
        var element_rozmery = $('p:contains("#cely-popis#")').nextUntil().nextAll().andSelf();
        $(element_rozmery).appendTo(".dsc-bottom"),
        $('p:contains("#cely-popis#")').remove(),
        $(".blog-background>p").last().after(' <span class="cely-popis">Celý popis</span>')
    }
    $(".cely-popis").on("click", (function() {
        $(".dsc-bottom").toggleClass("open-it"),
        $(this).toggleClass("open-dsc")
    }))
}
function mh_cart() {
    $(".p-quantity .tooltip-cart").length < 1 && $(".p-quantity").wrapInner('<span class="show-tooltip tooltip-cart" data-original-title="Změna množství v košíku je zakázána, pro změnu množství vložte nový produkt." role="tooltip"></span>')
}
function mh_cart_count() {
    const e = document.querySelector('i[data-testid="headerCartCount"]');
    e && (e.style.fontSize = "0", setTimeout((function() {
        e.textContent = getShoptetDataLayer().cart.length,
        e.style.fontSize = "16px"
    }), 100))
}
$(document).on("ShoptetDOMAdvancedOrderLoaded", (function() {
    $(".advanced-order .extras-wrap").prepend('<div class="extra step-back"><span class="btn inline-block btn-back" href="#" id="mhclose">Pokračovat v nákupu</span></div>'),
    $("body").on("click", "#mhclose", (function() {
        $("div#colorbox button#cboxClose").click()
    })),
    $.colorbox.resize(),
    $(".advanced-order-suggestion").text("Příslušenství"),
    celkem = $("body .celkem-metraz").text(),
    "" !== celkem && $("body .advanced-order > .h2:not(.advanced-order-suggestion)").after("<b>" + celkem + "</b>")
})),
$("#cart-wrapper").length && ($(".show-related").html("<strong>Doporučujeme</strong> přikoupit"), $(document).on("ShoptetDOMCartContentLoaded", (function() {
    $(".show-related").html("<strong>Doporučujeme</strong> přikoupit")
})), $(document).ready((function() {
    mh_cart()
})), document.addEventListener("ShoptetDOMCartContentLoaded", (function() {
    mh_cart()
})), document.addEventListener("ShoptetDOMContentLoaded", (function() {
    mh_cart()
}))),
$("html").on("submit", "#product-detail-form", (function(e) {
    e.preventDefault(),
    data_cart = "?simple_ajax_cart=1",
    $.post($(this).attr("action"), data_cart).done((function(e) {
        code_request = e.code,
        500 === code_request && mh_cart_count()
    }))
})),
$("html").on("click", "button.remove-item", (function() {
    $("#header .cart-count i").css("font-size", "0")
})),
document.addEventListener("ShoptetDOMCartContentLoaded", (function() {
    mh_cart_count()
})),
document.addEventListener("ShoptetCartDeleteCartItem", (function() {
    mh_cart_count()
})),
$(document).ready((function() {
    mh_cart_count()
}));

if ($(document).on("ready ShoptetDOMContentLoaded", (function() {
    $(".in-krok-2") && ($("#note").addClass("visible"), $("#add-note").click()),
    $(".id--7") && ($(".cart-table-header .p-cell:eq(1) span").html("Počet ks (m2)"), $(".cart-table-header .p-price").before("<td class='p-cell p-unit-price'>Počet bm</td>"), $(".removeable").each((function() {
        const e = $(this).find('input[name="amount"]'),
            t = parseFloat(e.val()),
            a = $(this).find(".main-link-variant:contains(Označení šíře role)").text().trim(),
            i = parseFloat(a.replace(/[^\d,.]/g, "").replace(/,/g, "."));
        console.log(i);
        const n = $(this).find(".p-price");
        if (a) {
            const e = t / i;
            $(n).before("<td class='p-cell p-unit-price'>" + e.toLocaleString().replace(".", ",") + " bm</td>")
        } else
            $(n).before("<td class='p-cell p-unit-price'></td>")
    })))
})), $(".type-category").length) {
    function mhcategory() {
        if ($('p:contains("#cist-vice#")').length) {
            $('.category-perex:not(".empty-content")').after('<div class="cat-bottom"></div>');
            var e = $('p:contains("#cist-vice#")').nextUntil().nextAll().andSelf();
            $(e).appendTo(".cat-bottom"),
            $('p:contains("#cist-vice#")').remove(),
            $('.category-perex:not(".empty-content") p').last().append(' <span class="cely-popis">Celý popis</span>')
        }
        $(".cely-popis").on("click", (function() {
            $(".cat-bottom").toggleClass("open-it"),
            $(this).toggleClass("open-dsc")
        })),
        $("#productsTop").appendTo(".category-content-wrapper"),
        $(".category-top>h4").appendTo(".category-content-wrapper"),
        $(".subcategories").insertAfter(".category-top"),
        $(".category-top").length && $('.category-top img[alt*="pozadí kategorie"]').length && ($(".category-top").addClass("has-image"), $('.category-top img[alt*="pozadí kategorie"]').closest("p").hide(), image = $('.category-top img[alt*="pozadí kategorie"]').attr("src"), $(".category-top").attr("style", 'background-image:url("' + image + '");background-size:cover;'))
    }
    $(document).ready((function() {
        mhcategory()
    })),
    document.addEventListener("ShoptetDOMPageContentLoaded", (function() {
        mhcategory()
    }))
}
const isCategoryPage = document.body.classList.contains("type-category");
if (isCategoryPage) {
    const e = window.innerWidth < 768 ? 250 : 500;
    let selector = $(".dm-perex").length ? ".popis-perex" : ".category-perex";

    document.addEventListener("DOMContentLoaded", function () {
        toggleExpandableText(selector, trans("CATEGORY.PEREX.SHOWMORE"), trans("CATEGORY.PEREX.SHOWLESS"), e);
    });
    $(document).ready(function(){
        toggleExpandableText(selector, trans("CATEGORY.PEREX.SHOWMORE"), trans("CATEGORY.PEREX.SHOWLESS"), e);
    })
    document.addEventListener("ShoptetDOMPageContentLoaded", function () {
        toggleExpandableText(selector, trans("CATEGORY.PEREX.SHOWMORE"), trans("CATEGORY.PEREX.SHOWLESS"), e);
    });
    
}
if ($(".in-pujcovna.type-category").length && ($(".category-top").append($(".zapujcka-banner")), document.addEventListener("ShoptetDOMPageContentLoaded", (function() {
    $(".category-top").append($(".zapujcka-banner"))
}))), $(".in-o-nas").length && $('div[itemprop="about"]').append('<div class="usp-page"><div class="container"></div></div>'), $(".in-kontakt").length && ($(".bg-white>.flexik>.left").html($(".custom-footer__contact .contact-box").clone().html()), $(".bg-white>.flexik>.left").append($("footer#footer .kontakt-inner p").last().clone()), $("footer#footer").before($('div[itemprop="about"] .g-maps')), $("footer#footer").before('<div class="usp-page"><div class="container"></div></div>')), $(".in-prodejna").length && ($("footer#footer").before($('div[itemprop="about"] .g-maps')), $("footer#footer").before('<div class="usp-page"><div class="container"></div></div>'), $(".image-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: !1,
    arrow: !0
}), $(".prodejna-slatinany .flexik .contact-boxik").html($(".custom-footer__contact .contact-box li").clone()), $(".prodejna-slatinany .flexik .adress .left").append($(".footer-kontakt .kontakt-inner p:nth-child(-n+2)").clone()), $(".prodejna-slatinany .flexik .adress .right").append($(".footer-kontakt .kontakt-inner p:nth-child(3)").clone())), $(".type-posts-listing").length && $(".news-item").each((function() {
    $(this).find(".description").append('<a href="' + $(this).find(".news-item-link-img").attr("href") + '" title="" class="read-article">Číst článek</a>')
})), $(".type-post").length) {
    function mhcustomblog() {
        $('.news-item:not(":nth-child(-n+3)")').remove(),
        $(".news-item").each((function() {
            $(this).find(".description").append('<a href="' + $(this).find(".news-item-link-img").attr("href") + '" title="" class="read-article">Číst článek</a>')
            $(this).find('img').attr('src', $(this).find('img').attr('data-src'))
        }))
    }
    $("footer#footer").before('<div class="blog"><div class="container"><h3>Ze světa koberců a podlah</h3><div class="blog-feed"></div></div></div>'),
    $("footer#footer").before('<div class="usp-page"><div class="container"></div></div>'),
    $(document).ready((function() {
        sessionStorage.blogfeed ? $(".blog .blog-feed").append(sessionStorage.blogfeed) : $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/blog/",
            success: function(e) {
                var t = shoptet.common.createDocumentFromString(e),
                    a = $(t).find("#newsWrapper").html();
                null !== a && ($(".blog .blog-feed").html(a), mhcustomblog()),
                sessionStorage.blogfeed = $(".blog .blog-feed").html()
            }
        })
    }))
}
sessionStorage.usp_page ? $(".usp-page .container").append(sessionStorage.usp_page) : $(document).on("ready", (function() {
    $(".usp-page .container").load("/ .benefitBanner .usp", (function() {
        sessionStorage.usp_page = $(".usp-page .container").html()
    }))
}));
const currency = dataLayer[0].shoptet.currency;
let currencySymbol;
"CZK" == currency ? currencySymbol = "Kč" : "EUR" == currency && (currencySymbol = "€");
const isProductDetail = $(".type-detail").length;
function hasProductBaleni() {
    $(".detail-parameters th .row-header-label").each((function() {
        "Page type:" == $(this).text().trim() && "balení" == $(this).parent().parent().find("td").text().trim() && $('<p class="pocet-v-baleni">Počet balení:</p>').prependTo(".p-to-cart-block .add-to-cart")
    }))
}
if (isProductDetail) {
    $(".p-detail-inner-header-mobile").insertBefore(".p-data-wrapper"),
    $(".ratings-and-brand").append($("#product-detail-form .p-code")),
    $(".basic-description").length && ($(".basic-description table").length && $(".basic-description table").wrap('<div class="overflow-table"></div>'), $(".p-short-description").append('<span class="detail-info"><a href="#description" class="" data-toggle="tab" data-external="1" data-force-scroll="true">Celý popis</a></span>')),
    $(".detail-parameters .availability-label").closest("tr").hide(),
    $(".shipping-options-row").hide(),
    $(".position--benefitProduct").insertBefore("footer#footer").wrapInner('<div class="container"></div>'),
    $(".p-final-price-wrapper").append('<div class="celkem"></div>'),

        $(".p-to-cart-block").after('<div class="skladovost"></div><div class="oblibene-doprava"></div>'),
        $(".skladovost").append($(".detail-parameters .availability-label").closest("td").html()),
        $(".oblibene-doprava").append($(".shipping-options-row td").html());
    
    $(".products-alternative-wrapper").length && ($("#p-detail-tabs li").last().after('<li class="shp-tab" data-width=""><a href="#products-alternative" class="shp-tab-link">Související produkty</a></li>'), $(".products-alternative").attr("id", "products-alternative")),
    $("#RecentlyViewed").length && $("#p-detail-tabs li").last().after('<li class="shp-tab" data-width=""><a href="#RecentlyViewed" class="shp-tab-link">Naposledy prohlížené</a></li>'),
    $("#relatedFiles").length && $("#description .basic-description").append($("#relatedFiles")),
    $(".products-alternative-wrapper").length > 0 && ($("#accordion-content").after('<div id="products-alternative" class="tab-pane fade" role="tabpanel"></div>'), $("#tab-content").after('<div id="products-alternative" class="tab-pane fade" role="tabpanel"></div>'), $(".products-alternative-header").appendTo("#products-alternative"), $(".products-alternative-wrapper").appendTo("#products-alternative"));
    const t = $('.extended-description tr:contains("Page type") td').text().normalize("NFD").replace(/[^\w]/g, "").toLowerCase();
    $(".p-variants-block").addClass(t),
    $("body").addClass("variant-" + t),
    $('body:not(".admin-logged") .extended-description tr:contains("Page type")').hide(),
    hasProductBaleni()
}
if ($(".pujcovna.p-variants-block").length) {
    let n;
    $(".p-to-cart-block").before('<span class="pujcovna-text btn btn-conversion">Zjistit dostupnost</span>'),
    $("html").on("click", ".pujcovna-text", (function() {
        $("body").addClass("pujcovna-yes")
    })),
    $("html").on("click", ".close", (function() {
        $("body").removeClass("pujcovna-yes")
    })),
    $(".p-data-wrapper").append('<div class="poup"><span class="close"></span><h2>Půjčovna</h2><div class="form"><p>Rezervace bude potvrzena naším pracovníkem - e-mailem nebo telefonicky, nejpozději do 24 hodin. Fotografie jsou pouze ilustrační a můžou se lišit od techniky uvedené na obrázku. Adresa pro vyzvednutí je: Podlahy Plotz s.r.o. T. G. Masaryka 333 538 21 Slatiňany</p><form action="/action/MailForm/SendEmail/" method="post" id="formContactpujcovna"><fieldset><input type="hidden" name="formId" value="1"><div class="form-group js-validated-element-wrapper"><label for="fullName"><span class="required-asterisk">Jméno a příjmení</span></label><input type="text" value="" name="fullName" id="fullName" class="form-control" required=""><span class="no-display">Nevyplňujte toto pole:</span><input type="text" name="surname" value="" class="no-display"></div><div class="form-group js-validated-element-wrapper"><label for="email"><span class="required-asterisk">E-mail</span></label><input type="email" value="" name="email" id="email" class="form-control" required=""></div><div class="form-group js-validated-element-wrapper"><label for="tel"><span class="required-asterisk">Telefon</span></label><input type="tel" value="" name="tel" id="tel" class="form-control" required=""></div><div class="form-group js-validated-element-wrapper"><label for="date"><span class="required-asterisk">datum zápujčky</span></label><input type="date" value="" name="date" id="date" class="form-control" required=""></div><div class="form-group js-validated-element-wrapper"><label for="delka"><span class="required-asterisk">Délka půjčení</span></label>' + $(".variant-list").html() + '</div><div class="form-group js-validated-element-wrapper"><label for="produkt"><span class="required-asterisk">Produkt</span></label><input type="text" value="" name="produkt" id="produkt" class="form-control" required=""></div><div class="form-group js-validated-element-wrapper"><label for="message"><span class="required-asterisk">Zpráva</span></label><textarea name="message" rows="7" class="form-control"></textarea></div><div class="form-group submit-wrapper"><input type="submit" value="Odeslat" class="btn btn-primary"></div></fieldset></form></div></div>'),
    $("#formContactpujcovna input#produkt").val($(".p-detail-inner-header h1").text().trim()),
    $("html").on("submit", "#formContactpujcovna", (function() {
        const e = $("#delka option:selected").val(),
            t = "Telefon: " + $("#tel").val() + "  ------\nDélka výpůjčky: " + e + " ---------Datum výpůjčky" + $("#date").val() + "---------\nProdukt:" + $("#produkt").val();
        $("textarea.form-control").val(t).removeClass("hide")
    })),
    $(".variant-list select").each((function() {
        const e = $(this).data("parameter-id");
        n = '<div class="select-variant pujcovna" data-id="' + e + '">',
        n += "<h2>" + $(this).data("parameter-name").trim() + "</h2>",
        n += '<div class="var_inner" data-id="' + e + '">',
        $(this).find("option").each((function() {
            const t = $(this).text(),
                a = $(this).val(),
                i = $(".p-to-cart-block .price-final").find(".price-final-holder." + e + "-" + a).text(),
                o = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent." + e + "-" + a).html(),
                r = i.replace(",", ".").replace(/ /g, "").replace("€", ""),
                s = parseFloat(r);
            $.isNumeric(a) && (n += '<div class="box" data-val="' + a + '" data-parameter-id="' + e + '">', n += '<div class="text">' + t + "</div>", n += '<div class="stock hide">' + o + "</div>", n += '<div class="price" data-price="' + s + '">' + i + "</div>", n += "</div>")
        })),
        n += "</div>",
        n += "</div>"
    })),
    $(".p-to-cart-block").before(n),
    $(".p-to-cart-block").hide(),
    $(".variant-list").hide(),
    $(".skladovost").hide(),
    $(".delivery-time-row").hide()
}
if ($(".metraz.p-variants-block").length) {
    let o;
    o = $(".p-final-price-wrapper .price-final>span").length > 1 ? $(".p-to-cart-block .price-final .default-variant .pr-list-unit").text().replace("/", "").trim() : $(".p-to-cart-block .price-final .pr-list-unit").text().replace("/", "").trim(),
    jednotka = "m2" === o ? "m" : $(".p-to-cart-block .price-final .pr-list-unit").text().replace("/", "").trim();
    let r,
        s = '<div class="kalkulacka-delka">';
    s += '<div class="custom-tooltip"><span class="popis">Délka (' + jednotka + '):</span><span class="tooltip-open"></span><div class="custom-tooltip-inner"><div>' + custom_tooltip + "</div></div></div>",
    s += '<label for="delka">Požadovaná délka</label>',
    s += '<div class="pocty"><div class="input-wrap"><span class="down">-</span><input type="number" data-min="1" id="delka" value="1" data-decimals="2" step="0.05" class="vypocet_delky"><span class="top">+</span></div><div class="celkem-metraz hide">Celkem <span>1</span> m<sup>2</sup></div></div>',
    s += "</div>",
    s += "</div>",
    $("#product-detail-form").append(s),
    $(".quantity").hide(),
    $(".variant-list select").each((function() {
        const e = $(this).data("parameter-id");
        r = '<div class="select-variant metraz" data-id="' + e + '">',
        r += "<h2>" + $(this).data("parameter-name").trim() + "</h2>",
        r += '<div class="var_inner" data-id="' + e + '">',
        $(this).find("option").each((function() {
            const t = $(this).text(),
                a = $(this).val();
            let i,
                n;
            i = 1 == $(".variant-list select").length ? $(".p-to-cart-block .price-final").find(".price-final-holder").text() : $(".p-to-cart-block .price-final").find(".price-final-holder." + e + "-" + a).text(),
            $(".p-final-price-wrapper .price-final>span").length > 1 ? (unit = $(".p-final-price-wrapper .price-final>span." + e + "-" + a + " .pr-list-unit").text().trim(), n = $(".p-final-price-wrapper .price-final>span." + e + "-" + a + '>span:not(".pr-list-unit")').text().trim().replace(",", ".").replace(/ /g, "").replace("€", ""), n = parseFloat(n)) : (unit = $(".p-to-cart-block .price-final .pr-list-unit").text().trim(), n = i.replace(",", ".").replace(/ /g, "").replace("€", ""), n = parseFloat(n)),
            attr_baleni = parseFloat(t.replace(",", ".").replace(/ /g, "").replace("€", "")),
            findtext = t.replace(",", ".").replace(/ /g, "").replace("€", ""),
            findtext = parseFloat(findtext),
            attr_baleni_price = (n * findtext).toFixed(2),
            $.isNumeric(a) && (r += '<div class="box" data-val="' + a + '" data-parameter-id="' + e + '" data-baleni="' + attr_baleni + '">', r += '<div class="text">' + t + "</div>", r += '<div class="price" data-price="' + n + '">' + n.ShoptetFormatAsCurrency() + " " + unit + "</div>", r += "</div>")
        })),
        r += "</div>",
        r += "</div>"
    })),
    $(".p-to-cart-block").before(r),
    $(".variant-list").hide()
}
function updatePackageInput() {
    if (!document.querySelector(".select-variant.baleni"))
        return;
    const e = () => {
            const e = (() => {
                const e = document.querySelector(".select-variant.baleni");
                if (e) {
                    if (code = e.getAttribute("data-code"), code)
                        return code;
                    console.error("getSelectedVariant code not found")
                } else
                    console.error("getSelectedVariant wrapper not found")
            })();
            if (!e)
                return void console.error("getCurrentMin selectedVariant not found");
            return mimeGetInfoByVariantID(e).minimumAmount
        },
        t = () => {
            const t = e(),
                a = document.querySelector(".select-variant.baleni .box.active").getAttribute("data-baleni");
            if (t) {
                if (a)
                    return dataMin = Math.ceil(t / a), dataMin;
                console.error("calculateMin activePackage not found")
            } else
                console.error("calculateMin currentMin not found")
        };
    (() => {
        const e = t();
        if (!e)
            return void console.error("replaceMin min not found");
        const a = document.querySelector(".amount_bal");
        a ? (a.setAttribute("data-min", e), a.setAttribute("min", e), a.value = e) : console.error("replaceMin input not found")
    })()
}
if ($(".bm.p-variants-block").length && (prunit = $(".p-to-cart-block .price-final .pr-list-unit").text().replace("/", "").trim(), "m2" === prunit ? jednotka = "m" : jednotka = $(".p-to-cart-block .price-final .pr-list-unit").text().replace("/", "").trim(), kalkulacka_delka = '<div class="kalkulacka-delka">', kalkulacka_delka += '<div class="custom-tooltip"><span class="popis">Délka (' + jednotka + '):</span><span class="tooltip-open"></span><div class="custom-tooltip-inner"><div>' + custom_tooltip + "</div></div></div>", kalkulacka_delka += '<label for="delka">Požadovaná délka</label>', kalkulacka_delka += '<div class="input-wrap"><span class="down">-</span><input type="number" data-min="1" id="delka" value="1" data-decimals="2" step="0.05" class="vypocet_delky"><span class="top">+</span></div>', kalkulacka_delka += "</div>", kalkulacka_delka += "</div>", $("#product-detail-form").append(kalkulacka_delka), $(".quantity").hide(), $(this).find("select").length && ($(".variant-list select").each((function() {
    data_parameter_id = $(this).data("parameter-id"),
    varianta_jeden_rozmer = '<div class="select-variant metraz" data-id="' + data_parameter_id + '">',
    varianta_jeden_rozmer += "<h2>" + $(this).data("parameter-name").trim() + "</h2>",
    varianta_jeden_rozmer += '<div class="var_inner" data-id="' + data_parameter_id + '">',
    $(this).find("option").each((function() {
        find_option_text = $(this).text(),
        find_option_value = $(this).val(),
        unit = $(".p-to-cart-block .price-final .pr-list-unit").text().trim(),
        1 == $(".variant-list select").length ? (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder").text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent").html()) : (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder." + data_parameter_id + "-" + find_option_value).text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent." + data_parameter_id + "-" + find_option_value).html()),
        attr_baleni = parseFloat(find_option_text.replace(".", ",").replace(/ /g, "").replace("€", "")),
        attr_price = find_option_price.replace(".", ",").replace(/ /g, "").replace("€", ""),
        attr_price = parseFloat(attr_price),
        findtext = find_option_text.replace(".", ",").replace(/ /g, "").replace("€", ""),
        findtext = parseFloat(findtext),
        attr_baleni_price = (attr_price * findtext).toFixed(2),
        $.isNumeric(find_option_value) && (varianta_jeden_rozmer += '<div class="box" data-val="' + find_option_value + '" data-parameter-id="' + data_parameter_id + '" data-baleni="' + attr_baleni + '">', varianta_jeden_rozmer += '<div class="text">' + find_option_text + "</div>", varianta_jeden_rozmer += '<div class="baleni-obsah">balení: ' + find_option_text + "</div>", varianta_jeden_rozmer += '<div class="price" data-price="' + attr_price + '">' + attr_price.ShoptetFormatAsCurrency() + " " + unit + "</div>", varianta_jeden_rozmer += "</div>")
    })),
    varianta_jeden_rozmer += "</div>",
    varianta_jeden_rozmer += "</div>"
})), $(".p-to-cart-block").before(varianta_jeden_rozmer), $(".variant-list").hide())), $(".bm.p-variants-block").length && ($(".p-to-cart-block .add-to-cart .quantity").before('<div class="custom-tooltip"><span class="popis">Délka (' + $(".p-to-cart-block .price-final .pr-list-unit").text().replace("/", "").trim() + '):</span><span class="tooltip-open"></span><div class="custom-tooltip-inner"><div>' + custom_tooltip_bm + "</div></div></div>"), $(".p-to-cart-block .add-to-cart").appendTo("#product-detail-form"), $(".price-measure").hide()), $(".kusovykoberec.p-variants-block").length && ($(".variant-list select").each((function() {
    data_parameter_id = $(this).data("parameter-id"),
    varianta_jeden_rozmer = '<div class="select-variant jednoduchavarianta" data-id="' + data_parameter_id + '">',
    varianta_jeden_rozmer += "<h2>" + $(this).data("parameter-name").trim() + "</h2>",
    varianta_jeden_rozmer += '<div class="var_inner" data-id="' + data_parameter_id + '">',
    $(this).find("option").each((function() {
        find_option_text = $(this).text(),
        find_option_value = $(this).val(),
        1 == $(".variant-list select option").length ? (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder").text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".availability-label").closest("td").html()) : (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder." + data_parameter_id + "-" + find_option_value).text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent." + data_parameter_id + "-" + find_option_value).html()),
        attr_price = find_option_price.replace(",", ".").replace(/ /g, "").replace("€", ""),
        attr_price = parseFloat(attr_price),
        $.isNumeric(find_option_value) && (varianta_jeden_rozmer += '<div class="box" data-val="' + find_option_value + '" data-parameter-id="' + data_parameter_id + '">', varianta_jeden_rozmer += '<div class="text">' + find_option_text + "</div>", varianta_jeden_rozmer += '<div class="stock">' + find_option_availability + "</div>", varianta_jeden_rozmer += '<div class="price" data-price="' + attr_price + '">' + find_option_price + "</div>", varianta_jeden_rozmer += "</div>")
    })),
    varianta_jeden_rozmer += "</div>",
    varianta_jeden_rozmer += "</div>"
})), $(".p-to-cart-block").before(varianta_jeden_rozmer), $(".variant-list").hide(), $(".skladovost").hide()), $(".baleni.p-variants-block").length) {
    $(".variant-list").each((function() {
        const e = $(this).find("select").data("parameter-id");
        let t = '<div class="select-variant baleni" data-id="' + e + '">';
        if (t += "<h2>" + $(this).find("select").data("parameter-name").trim() + "</h2>", t += '<div class="var_inner" data-id="' + e + '">', $(this).find("select").length > 0) {
            const a = $(this).find("option"),
                i = a.length > 1;
            a.each((function(a) {
                if (i && 0 === a)
                    return !0;
                const n = $(this).text(),
                    o = $(this).val();
                let r,
                    s,
                    l = n;
                if (1 === $(".variant-list select option").length)
                    r = $(".p-to-cart-block .price-final").find(".price-final-holder").text(),
                    s = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent").html();
                else {
                    1 === $(".p-to-cart-block .price-final-holder").length ? (r = $(".p-to-cart-block .price-final").find(".price-final-holder").text(), s = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent").html()) : (r = $(".p-to-cart-block .price-final").find(".price-final-holder." + e + "-" + o).text(), s = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent." + e + "-" + o).html())
                }
                let d = r.replace(",", ".").replace(/ /g, "").replace("€", "");
                d = parseFloat(d);
                let c,
                    p = parseFloat(n.replace(",", ".").replace(/ /g, "").replace("€", ""));
                isNaN(p) && (c = $(".p-final-price-wrapper .price-measure>span").length > 1 ? parseFloat($(".p-final-price-wrapper .price-measure>span.parameter-dependent." + e + "-" + o).text().replace(/ /g, "").replace(",", ".").replace("€", "")) : parseFloat($(".p-final-price-wrapper .price-measure>span").text().replace(/ /g, "").replace(",", ".").replace("€", "")), l = (d / c).toFixed(3), l = l.toLocaleString().replace(".", ",") + " m²", p = (d / c).toFixed(3)),
                $.isNumeric(o) && (t += '<div class="box" data-val="' + o + '" data-parameter-id="' + e + '" data-baleni="' + p + '">', t += '<div class="text">' + n + "</div>", t += '<div class="baleni-obsah">balení: ' + l + "</div>", t += '<div class="price" data-price="' + d + '">' + d.toFixed(2) + " /m²</div>", t += "</div>")
            }))
        }
        $(this).find("select").length < 1 && (t += $(this).html()),
        t += "</div>",
        t += "</div>",
        $(".p-to-cart-block").before(t)
    })),
    kalkulacka_baleni = '<div class="kalkulacka-baleni">',
    kalkulacka_baleni += "<h3>Zadejte rozměry místnosti nebo celkovou plochu:</h3>",
    kalkulacka_baleni += '<div class="flexik">',
    kalkulacka_baleni += '<div class="col-4 delka-sirka">',
    kalkulacka_baleni += '<label for="sirka">Šířka (m):</label>',
    kalkulacka_baleni += '<div class="input-wrap"><span class="down">-</span><input type="number" data-min="1" id="sirka" value="1" data-decimals="2" step="0.05" class="vypocet_plochy"><span class="top">+</span></div>',
    kalkulacka_baleni += "</div>",
    kalkulacka_baleni += '<div class="col-4 delka-sirka">',
    kalkulacka_baleni += '<label for="delka">Délka (m):</label>',
    kalkulacka_baleni += '<div class="input-wrap"><span class="down">-</span><input type="number" data-min="1" id="delka" value="1" data-decimals="2" step="0.05" class="vypocet_plochy"><span class="top">+</span></div>',
    kalkulacka_baleni += "</div>",
    kalkulacka_baleni += '<div class="col-4 last">',
    kalkulacka_baleni += '<label for="plocha">Celková plocha (m²):</label>',
    kalkulacka_baleni += '<div class="input-wrap"><span class="down hide">-</span><input type="number" data-min="1" data-decimals="2"  id="plocha" value="1" step="0.05" class="vypocet_plochy"><span class="pseude-plocha"></span><span class="top hide">+</span></div>',
    kalkulacka_baleni += "</div>",
    kalkulacka_baleni += "</div>",
    kalkulacka_baleni += '<p>Velikost místnosti je <span class="velikost">1</span>m². Doporučujeme prořez 8%. <br>Budete tak potřebovat <span class="baleni">1</span> balení včetně prořezu.</p>',
    kalkulacka_baleni += "</div>";
    const l = () => {
        if (!document.querySelector(".select-variant.baleni .box.active")) {
            document.querySelector(".select-variant.baleni .box").click()
        }
    };
    setTimeout((function() {
        l(),
        updatePackageInput()
    }), 300),
    $(".add-to-cart .quantity").before('<div class="zadane-baleni-wrap"><span class="down-bal">-</span><input type="number" name="amount" value="1" class="amount_bal" autocomplete="off" data-decimals="0" data-max="9999" data-min="1" step="1" min="1" max="9999" data-testid="cartAmount" aria-label="Množství"><span class="top-bal">+</span></div>'),
    $(".p-to-cart-block").before(kalkulacka_baleni),
    $(".p-to-cart-block").prepend('<div class="celkem-plocha">Celkem obdržíte: <span>' + $('.add-to-cart input[name="amount"]').val().replace(".", ",") + "</span> m<sup>2</sup></div>"),
    $(".variant-list").hide(),
    $(".add-to-cart .quantity").hide()
}
function variant_find(e) {
    multiplevariant = [],
    $(".select-variant").each((function() {
        $(this).attr("data-code") && multiplevariant.push($(this).attr("data-code"))
    })),
    1 == $(".variant-list").length && ($("body").removeClass("disabled-add-to-cart"), variant_one = multiplevariant[0], $(".p-final-price-wrapper>.price-standard>span").length > 1 && ($(".p-final-price-wrapper>.price-standard").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".p-final-price-wrapper>.price-standard").find(".parameter-dependent." + variant_one).removeClass("noDisplay").removeClass("no-display")), $(".p-final-price-wrapper .price-final>span").length > 1 ? $(".p-to-cart-block .price-final .price-final-holder." + variant_one).length > 0 && ($(".p-to-cart-block .price-final").find(".price-final-holder").addClass("noDisplay").addClass("no-display"), $(".p-to-cart-block .price-final").find(".price-final-holder." + variant_one).removeClass("noDisplay").removeClass("no-display"), $(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent." + variant_one).removeClass("noDisplay").removeClass("no-display"), $(".skladovost").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".skladovost").find(".parameter-dependent." + variant_one).removeClass("noDisplay").removeClass("no-display")) : ($(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent." + variant_one).removeClass("noDisplay").removeClass("no-display"), $(".skladovost").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".skladovost").find(".parameter-dependent." + variant_one).removeClass("noDisplay").removeClass("no-display"))),
    2 == $(".variant-list").length && (variant_two = multiplevariant[1] + "-" + multiplevariant[0], -1 === variant_two.indexOf("undefined") && $("body").removeClass("disabled-add-to-cart"), $(".p-to-cart-block .price-final .price-final-holder." + variant_two).length > 0 && ($(".p-to-cart-block .price-final").find(".price-final-holder").addClass("noDisplay").addClass("no-display"), $(".p-to-cart-block .price-final").find(".price-final-holder." + variant_two).removeClass("noDisplay").removeClass("no-display")), $(".p-detail-inner-header-mobile .p-code .parameter-dependent." + variant_two).length > 0 && ($(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent." + variant_two).removeClass("noDisplay").removeClass("no-display")), $(".skladovost .parameter-dependent." + variant_two).length > 0 && ($(".skladovost").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".skladovost").find(".parameter-dependent." + variant_two).removeClass("noDisplay").removeClass("no-display"))),
    3 == $(".variant-list").length && (variant_three = multiplevariant[1] + "-" + multiplevariant[2] + "-" + multiplevariant[0], -1 === variant_three.indexOf("undefined") && $("body").removeClass("disabled-add-to-cart"), $(".p-to-cart-block .price-final .price-final-holder." + variant_three).length > 0 && ($(".p-to-cart-block .price-final").find(".price-final-holder").addClass("noDisplay").addClass("no-display"), $(".p-to-cart-block .price-final").find(".price-final-holder." + variant_three).removeClass("noDisplay").removeClass("no-display")), $(".p-detail-inner-header-mobile .p-code .parameter-dependent." + variant_three).length > 0 && ($(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".p-detail-inner-header-mobile .p-code").find(".parameter-dependent." + variant_three).removeClass("noDisplay").removeClass("no-display")), $(".skladovost .parameter-dependent." + variant_three).length > 0 && ($(".skladovost").find(".parameter-dependent").addClass("noDisplay").addClass("no-display"), $(".skladovost").find(".parameter-dependent." + variant_three).removeClass("noDisplay").removeClass("no-display")))
}
function init_price() {
    $(".p-final-price-wrapper .price-final-holder").length > 1 ? (price = $(".p-final-price-wrapper .price-final-holder:not(.no-display)").text(), price = parseFloat(price.replace(",", ".").replace(/ /g, "").replace("m2").trim().replace(/[^\d.-]/g, "").replace("€", ""))) : (price = $(".p-final-price-wrapper .price-final-holder").text(), price = parseFloat(price.replace(",", ".").replace(/ /g, "").replace("m2").trim().replace("m2", "").replace(/[^\d.-]/g, "").replace("€", "")));
    if ($(".box[data-baleni]").length > 0) {
        const e = $(".box[data-baleni].active").attr("data-baleni");
        price *= e
    }
    const e = $(".kalkulacka-delka").length > 0 ? $(".kalkulacka-delka #delka").attr("data-min") : $('.add-to-cart input[name="amount"]').val();
    let t = price * e;
    $(".celkem").html("Celkem " + t.ShoptetFormatAsCurrency())
}
function find_price() {
    $(".p-final-price-wrapper .price-final-holder").length > 1 ? (price = $(".p-final-price-wrapper .price-final-holder:not(.no-display)").text(), price = parseFloat(price.replace(",", ".").replace(/ /g, "").replace("m2").trim().replace(/[^\d.-]/g, "").replace("€", ""))) : (price = $(".p-final-price-wrapper .price-final-holder").text(), price = parseFloat(price.replace(",", ".").replace(/ /g, "").replace("m2").trim().replace("m2", "").replace(/[^\d.-]/g, "").replace("€", "")));
    const e = $(".kalkulacka-delka").length > 0 ? $(".kalkulacka-delka #delka").attr("data-min") : $('.add-to-cart input[name="amount"]').val();
    let t = price * e;
    $(".celkem").html("Celkem " + t.ShoptetFormatAsCurrency())
}
function kalkulacka() {
    if ($("#product-detail-form").attr("novalidate", "novalidate"), $(".variant-bm").length && (zadana_delka = parseFloat($(".vypocet_delky").val()), isNaN(zadana_delka) || ($(".add-to-cart .quantity input").val(zadana_delka), number_quantity = $(".add-to-cart .amount").val(), vypocet_delky = $(".vypocet_delky").val(), price_final = price * vypocet_delky, price_final = price_final, $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency())), find_price()), $(".variant-metraz").length && (varianta = $(".select-variant .box.active").attr("data-baleni"), zadana_delka = $(".vypocet_delky").val(), cena = price, celkova_cena = varianta * zadana_delka, isNaN(celkova_cena) || ($(".celkem-metraz").removeClass("hide"), $(".add-to-cart .quantity input").val(celkova_cena.toFixed($(".add-to-cart .quantity input").data("decimals")))), $(".celkem-metraz span").html(celkova_cena.toFixed(3)), find_price(), number_quantity = $(".add-to-cart .amount").val(), price_final = varianta * zadana_delka * $('.p-final-price-wrapper .price-final-holder:not(".no-display")').attr("data-price"), price_final = price_final, $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency())), $(".variant-baleni").length) {
        if ($(".select-variant .box").length > 0) {
            min_mnozstvi = $(".add-to-cart .quantity .amount").attr("min"),
            decimal_data = $(".add-to-cart .quantity .amount").data("decimals"),
            zadana_sirka = $("input#sirka").val(),
            zadana_delka = $("input#delka").val();
            $(".box.active").length > 0 ? (plocha_baleni = parseFloat($(".box.active").data("baleni")), vypocet_plochy = (zadana_sirka * zadana_delka).toFixed(3).replace(",", "."), vypocet_plochy = parseFloat(vypocet_plochy), trojclenka = 108 * vypocet_plochy / 100, baleni_plocha = Math.ceil(trojclenka / plocha_baleni) * min_mnozstvi, baleni_plocha = baleni_plocha.toFixed(decimal_data), baleni_pocet = (baleni_plocha / plocha_baleni).toFixed(0), isNaN(baleni_plocha) ? ($(".kalkulacka-baleni .plocha_baleni").html("dle zvolené varianty"), $(".add-to-cart .quantity input").val(baleni_plocha)) : ($(".kalkulacka-baleni .baleni").html(baleni_pocet), $(".add-to-cart input.amount_bal").val(baleni_pocet), $(".add-to-cart input.amount_bal").attr("value", baleni_pocet), $(".add-to-cart .quantity input").val(baleni_plocha), $(".p-to-cart-block .celkem-plocha span").html((plocha_baleni * baleni_pocet).toFixed(3).replace(".", ","))), $(".kalkulacka-baleni .velikost").html(vypocet_plochy), $(".pseude-plocha").text(vypocet_plochy), $(".p-final-price-wrapper .price-final>span").length > 0 ? price = parseFloat($('.p-final-price-wrapper .price-final>span:not(".no-display")').text().replace(",", ".").trim().replace(/ /g, "").replace("€", "")) : price = parseFloat($(".p-final-price-wrapper .price-final").text().replace(",", ".").trim().replace(/ /g, "").replace("€", "")), number_quantity = $(".add-to-cart .amount").val(), price_final = price * number_quantity, price_final = price_final, $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency())) : (plocha_baleni = 1, vypocet_plochy = (zadana_sirka * zadana_delka).toFixed(3).replace(",", "."), vypocet_plochy = parseFloat(vypocet_plochy), trojclenka = 108 * vypocet_plochy / 100, baleni_plocha = Math.ceil(trojclenka / plocha_baleni) * min_mnozstvi, baleni_plocha = baleni_plocha.toFixed(decimal_data), baleni_pocet = (baleni_plocha / plocha_baleni).toFixed(0), isNaN(baleni_plocha) ? ($(".kalkulacka-baleni .plocha_baleni").html("dle zvolené varianty"), $(".add-to-cart .quantity input").val(baleni_plocha)) : ($(".kalkulacka-baleni .baleni").html(baleni_pocet), $(".add-to-cart input.amount_bal").val(baleni_pocet), $(".add-to-cart input.amount_bal").attr("value", baleni_pocet), $(".add-to-cart .quantity input").val(baleni_plocha), $(".p-to-cart-block .celkem-plocha span").html(plocha_baleni * baleni_pocet)), $(".kalkulacka-baleni .velikost").html(vypocet_plochy), $(".pseude-plocha").text(vypocet_plochy), $(".p-final-price-wrapper .price-final>span").length > 0 ? price = parseFloat($('.p-final-price-wrapper .price-final>span:not(".no-display")').text().replace(",", ".").trim().replace(/ /g, "").replace("€", "")) : price = parseFloat($(".p-final-price-wrapper .price-final").text().replace(",", ".").trim().replace(/ /g, "").replace("€", "")), number_quantity = $(".add-to-cart .amount").val(), price_final = price * number_quantity, price_final = price_final, $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency()))
        }
    } else
        zadana_sirka = $("input#sirka").val(),
        zadana_delka = $("input#delka").val(),
        vypocet_plochy = (zadana_sirka * zadana_delka).toFixed($(".add-to-cart .quantity input").data("decimals")),
        plocha_baleni = $(".box.active").data("baleni"),
        baleni_plocha = Math.ceil(vypocet_plochy / plocha_baleni),
        isNaN(baleni_plocha) || setTimeout((function() {
            $(".kalkulacka-baleni .velikost").html(vypocet_plochy),
            $(".kalkulacka-baleni .plocha_baleni").html(baleni_plocha),
            $(".add-to-cart .quantity input").val(baleni_plocha)
        }), 10),
        $(".pseude-plocha").text(vypocet_plochy),
        number_quantity = $(".add-to-cart .amount").val(),
        price_final = price * number_quantity,
        price_final = price_final,
        $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency())
}
function kalkulacka_plocha() {
    $(".pseude-plocha").length && setTimeout((function() {
        $('.pseude-plocha[style="display: none;"]').length > 0 || $("input#plocha").val(parseFloat($(".pseude-plocha").text().replace(",", "."))),
        vypocet_plochy_input = $("input#plocha").val(),
        trojclenka = 108 * vypocet_plochy_input / 100;
        const e = $(".box.active").length > 0;
        plocha_baleni_input = e ? $(".box.active").data("baleni") : 1,
        min_mnozstvi = $(".add-to-cart .quantity .amount").attr("data-min"),
        baleni_plocha = Math.ceil(trojclenka / plocha_baleni_input),
        $(".kalkulacka-baleni .velikost").html(vypocet_plochy_input),
        $(".kalkulacka-baleni .baleni").html(baleni_plocha),
        $(".zadane-baleni-wrap .amount_bal").val(baleni_plocha),
        $(".add-to-cart .quantity input").val(baleni_plocha * plocha_baleni_input),
        number_quantity = parseFloat($(".add-to-cart .amount").val()).toFixed(2),
        $(".add-to-cart .amount").val(number_quantity),
        vypocet_celkem_obdrzite = baleni_plocha * parseFloat(plocha_baleni_input),
        price_final = vypocet_celkem_obdrzite * price,
        $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency()),
        $(".p-to-cart-block .celkem-plocha span").html((baleni_plocha * plocha_baleni_input).toFixed(3).replace(".", ","))
    }), 10)
}
function local_prichute_cart() {
    if ($(".in-kosik").length) {
        if ($(".removeable").each((function() {
            $(this).find(".main-link-surcharges").length && ($(this).addClass("have-surcharge"), $(this).find(".main-link-surcharges").each((function() {
                split_text = $(".main-link-surcharges").text().split("Příplatky:")[1].replace(/,/g, "</li><li>").split("#"),
                $(this).html("<ul><li>" + split_text + "</li></ul>")
            })), $(this).find(".main-link-surcharges li").each((function() {
                $(this).html($(this).text().split(",")[0])
            })))
        })), JSON.parse(sessionStorage.getItem("rozmern_na_miru")))
            var e = JSON.parse(sessionStorage.getItem("rozmern_na_miru"));
        else
            e = "";
        e.length && $(".cart-table tr.removeable .cart-p-image a").each((function() {
            href = $(this).attr("href"),
            priplateky = $(this).closest(".removeable").find(".main-link-surcharges").text(),
            priplateky = priplateky.trim().replace(/ /g, "");
            for (var t = 0; t < e.length; t++)
                priplatky_porovnej = e[t].priplatek.trim().replace(/ /g, "").replace(/,/g, ""),
                e[t].url.includes(href) && priplatky_porovnej === priplateky && $(this).closest("tr.removeable").find(".p-name").append('<div class="poznamka_wrap"><div class="text"><span class="remove-array"></span><ul><li data-vysivka="' + e[t].rozmer + '"><span>Rozměr produktu:</span> ' + e[t].rozmer + "</li></ul></div></div></div>")
        })),
        $('.text ul li[data-vysivka="undefined"]').remove(),
        $(".poznamka_wrap ul li").each((function() {
            $(this).attr("data-vysivka") || $(this).remove()
        }))
    }
}
if ($(".bezvariant.p-variants-block").length && $(".p-variants-block .variant-list").length > 0 && $(".p-variants-block .variant-list").each((function(e) {
    $(this).find("select").length && (data_parameter_id = $(this).find("select").data("parameter-id"), varianta_jeden_rozmer = '<div class="select-variant kusove" data-id="' + data_parameter_id + '">', varianta_jeden_rozmer += "<h2>" + $(this).find(".variant-label").text().trim() + "</h2>", varianta_jeden_rozmer += '<div class="var_inner" data-id="' + data_parameter_id + '">', $(this).find("select option").length > 0 && $(this).find("select option").each((function() {
        find_option_text = $(this).text(),
        find_option_value = $(this).val(),
        1 == $(".p-final-price-wrapper .price-final>span").length ? (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder").text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent").html()) : (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder." + data_parameter_id + "-" + find_option_value).text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent." + data_parameter_id + "-" + find_option_value).html()),
        attr_price = find_option_price.replace(",", ".").replace(/ /g, "").replace("€", ""),
        attr_price = parseFloat(attr_price),
        $.isNumeric(find_option_value) && (varianta_jeden_rozmer += '<div class="box" data-val="' + find_option_value + '" data-parameter-id="' + data_parameter_id + '">', varianta_jeden_rozmer += '<div class="text">' + find_option_text + "</div>", varianta_jeden_rozmer += '<div class="price" data-price="' + attr_price + '">' + find_option_price + "</div>", varianta_jeden_rozmer += "</div>")
    })), $(this).find("select option").length < 1 && (varianta_jeden_rozmer += $(this).html()), varianta_jeden_rozmer += "</div>", varianta_jeden_rozmer += "</div>", $(".p-to-cart-block").before(varianta_jeden_rozmer), $(".variant-list").hide())
})), 1 == $(".variant-list select").length && 1 == $(".variant-list select option").length && ($(".box").first().addClass("active"), find_price()), $("html").on("click", ".mobile .tooltip-open", (function() {
    $(".custom-tooltip-inner").toggleClass("open-it")
})), $(".desktop .tooltip-open").hover((function() {
    $(".custom-tooltip-inner").addClass("open-it")
}), (function() {
    $(".custom-tooltip-inner").removeClass("open-it")
})), $("html").on("click", ".add-to-cart .quantity button", (function() {
    setTimeout((function() {
        find_price()
    }), 10)
})), $("html").on("click", ".top", (function() {
    step = $(this).closest(".input-wrap").find("input").attr("step"),
    value = $(this).closest(".input-wrap").find("input").val(),
    min_data = $(this).closest(".input-wrap").find("input").attr("min"),
    number = parseFloat(value) + parseFloat(step),
    number = number.toFixed($(this).closest(".input-wrap").find("input").attr("data-decimals")),
    $(this).closest(".input-wrap").find("input").val(number),
    $(this).closest(".input-wrap").find("input").attr("value", number),
    kalkulacka(),
    $("input#plocha").val(1).attr("value", 1)
})), $("html").on("click", ".down", (function() {
    step = $(this).closest(".input-wrap").find("input").attr("step"),
    value = $(this).closest(".input-wrap").find("input").val(),
    actual_value = $(this).closest(".input-wrap").find("input").attr("value"),
    min_data = $(this).closest(".input-wrap").find("input").attr("min"),
    min_data == actual_value || (number = parseFloat(value) - parseFloat(step), number = number.toFixed($(this).closest(".input-wrap").find("input").attr("data-decimals")), $(this).closest(".input-wrap").find("input").val(number), $(this).closest(".input-wrap").find("input").attr("value", number)),
    kalkulacka(),
    $("input#plocha").val(1).attr("value", 1)
})), $("html").on("click", ".top-bal", (function() {
    const e = $(this).closest(".zadane-baleni-wrap").find("input").attr("step"),
        t = $(this).closest(".zadane-baleni-wrap").find("input").val();
    min_data = $(this).closest(".zadane-baleni-wrap").find("input").attr("min"),
    number = parseFloat(t) + parseFloat(e),
    number = number.toFixed(0),
    $(this).closest(".zadane-baleni-wrap").find("input").val(number),
    $(this).closest(".zadane-baleni-wrap").find("input").attr("value", number)
})), $("html").on("click", ".down-bal", (function() {
    step = $(this).closest(".zadane-baleni-wrap").find("input").attr("step"),
    value = $(this).closest(".zadane-baleni-wrap").find("input").val(),
    actual_value = $(this).closest(".zadane-baleni-wrap").find("input").attr("value"),
    min_data = $(this).closest(".zadane-baleni-wrap").find("input").attr("min"),
    min_data == $(this).closest(".zadane-baleni-wrap").find("input").val() || (number = parseFloat(value) - parseFloat(step), number = number.toFixed(0), $(this).closest(".zadane-baleni-wrap").find("input").val(number), $(this).closest(".zadane-baleni-wrap").find("input").attr("value", number))
})), $(".variant-metraz").length && (varianta = $(".select-variant .box.active").attr("data-baleni"), zadana_delka = $(".vypocet_delky").val(), celkova_cena = varianta * zadana_delka, $(".celkem-metraz span").html(celkova_cena.toFixed(3))), $(".variant-metraz .pocty input").on("input blur", (function() {
    kalkulacka(),
    kalkulacka_plocha()
})), $(".variant-bm .input-wrap").on("input", (function() {
    kalkulacka(),
    kalkulacka_plocha()
})), $(".variant-metraz").length && $("html").on("click", "button.add-to-cart-button", (function() {
    varianta = $(".select-variant .box.active").attr("data-baleni"),
    zadana_delka = $(".vypocet_delky").val(),
    cena = price,
    celkova_cena = varianta * zadana_delka,
    $(".add-to-cart .quantity input").val(celkova_cena.toFixed($(".add-to-cart .quantity input").data("decimals"))),
    find_price(),
    number_quantity = $(".add-to-cart .amount").val(),
    price_final = price * number_quantity,
    price_final = price_final,
    $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency())
})), $(document).ready((function() {
    $(".kalkulacka-baleni").length && kalkulacka()
})), $("html").on("click", ".var_inner .box", (function() {
    kalkulacka(),
    updatePackageInput()
})), $(".flexik").on("input", (function() {
    kalkulacka(),
    kalkulacka_plocha()
})), $(document).ready((function() {
    $(".vypocet_plochy").on("change", (function() {
        var e = parseFloat($(this).attr("step")),
            t = parseFloat($(this).val()),
            a = Math.ceil(t / e) * e;
        $(this).val(a.toFixed(2))
    })),
    $(".vypocet_delky").on("change", (function() {
        var e = parseFloat($(this).attr("step")),
            t = parseFloat($(this).val()),
            a = Math.ceil(t / e) * e;
        $(this).val(a.toFixed(2))
    }))
})), $("html").on("click", ".pseude-plocha", (function() {
    $(this).hide(),
    $("#plocha").show(),
    $(".pseude-plocha").text($(".vypocet_plochy#plocha").val())
})), $("html").on("click", ".delka-sirka", (function() {
    $(".pseude-plocha").show(),
    $("#plocha").hide(),
    $(".vypocet_plochy#plocha").val($(".pseude-plocha").text())
})), $("html").on("input blur", ".delka-sirka", (function() {
    kalkulacka(),
    kalkulacka_plocha()
})), $("html").on("click", ".open-text", (function() {
    $(this).closest(".surcharge-list").toggleClass("open-info")
})), $(".surcharge-parameter option").each((function() {
    $(this).html((function() {
        return $(this).html().replace("Vyberte příplatek", "Možné úpravy od Plotzáka:")
    }))
})), $(".parameter-id-139 option").each((function() {
    $(this).html((function() {
        return $(this).html().replace("Vyberte příplatek", "Vyberte řez (ks)")
    })),
    $(this).html((function() {
        return $(this).html().replace("+0 Kč", "- Zdarma")
    }))
})), $("html").on("click", '.surcharge-box:not(".info")', (function() {
    data_surcharge_id = $(this).attr("data-parameter-id"),
    find_surcharge_value = $(this).attr("data-val"),
    $(this).toggleClass("active"),
    $(this).hasClass("active") && $(".parameter-id-" + data_surcharge_id).val(find_surcharge_value),
    $(this).hasClass("active") || $(".parameter-id-" + data_surcharge_id).val("")
})), $("html").on("click", ".surcharge-box-message", (function() {
    data_surcharge_id = $(this).attr("data-parameter-id"),
    find_surcharge_value = $(this).attr("data-val"),
    $(this).toggleClass("active"),
    $("body").addClass("open-poznamka"),
    $(this).hasClass("active") && $(".parameter-id-" + data_surcharge_id).val(find_surcharge_value),
    $(this).hasClass("active") || $(".parameter-id-" + data_surcharge_id).val("")
})), $("html").on("click", ".narez-popup .close, .narez-popup .potvrdit", (function() {
    $("body").removeClass("open-poznamka")
})), $(document).ready((function() {
    setTimeout((function() {
        init_price()
    }), 10)
})), $(".narez-popup .potvrdit").on("click", (function() {
    var e = [];
    (r = sessionStorage.getItem("rozmern_na_miru")) && (e = JSON.parse(r));
    var t = e.length + 1,
        a = $('#product-detail-form meta[itemprop="sku"]').attr("content"),
        i = (i = $(".p-detail-inner-header h1").text()).trim();
    zvolene_priplatky = [],
    $(".surcharge-list select").each((function() {
        $(this).prop("required") ? (text = $(this).find("option:selected").text(), nadpis = $(this).attr("data-parameter-name"), zvolene_priplatky += nadpis + "-" + text) : zvolene_priplatky += ""
    })),
    rozmer = $(".narez-popup textarea").val();
    var n = new Date;
    n.setTime(n.getTime());
    var o = n.toGMTString();
    entry_url = window.location.pathname,
    e.push({
        id: t,
        kod_produktu: a,
        url: entry_url,
        product_name: i,
        rozmer: rozmer,
        priplatek: zvolene_priplatky,
        datum: o
    });
    var r = e.sort((function(e, t) {
        var a = new Date(e.date);
        return new Date(t.date) - a
    }));
    50 === Object.keys(r).length ? (r.pop(), sessionStorage.setItem("rozmern_na_miru", JSON.stringify(r))) : sessionStorage.setItem("rozmern_na_miru", JSON.stringify(r))
})), $(".in-cart, .in-kosik").length && ($(document).ready((function() {
    local_prichute_cart()
})), document.addEventListener("ShoptetCartSetCartItemAmount", (function() {
    local_prichute_cart()
})),
document.addEventListener("ShoptetDOMCartContentLoaded", (function() {
    local_prichute_cart()
}))
), $(".in-dekujeme").length && sessionStorage.removeItem("rozmern_na_miru"), url_odrezku.length > 1) {
    let d = (new Date).getHours();
    $(".type-detail").length && (file = url_odrezku + d, $.get(file, (function(e) {
        $(".custom_dokup").length < 1 && $(".p-detail-inner").after('<div class="custom_dokup"><h2 class="doprodej-title hide">Výprodej kusových rozměrů</h2><div class="dokup"></div></div>'),
        lines = e.split("\r\n"),
        $(".p-detail-inner-header-mobile .p-code .parameter-dependent").length ? find_code = $('.p-detail-inner-header-mobile .p-code .parameter-dependent:not(".no-display")').text().trim() : find_code = $(".p-detail-inner-header-mobile .p-code td span").text().trim();
        for (var t = 0; t <= lines.length - 2; t++)
            radek = lines[t],
            spl = radek.split(";"),
            code = spl[0].split("//")[0],
            code === find_code && (pname = spl[2], price = spl[3], stock = spl[4], stock > 0 ? (stock = "Skladem", stock_class = stock.normalize("NFD").replace(/[^\w]/g, "").toLowerCase()) : (stock = "Není skladem", stock_class = "0"), $(".doprodej-title").removeClass("hide"), $(".dokup").append('<div class="product"><div class="name">' + pname + '</div><div class="right"><div class="availability"><span class="' + stock_class + '">' + stock + '</span></div><div class="cart"><p>' + price + ' Kč/ks</p><span data-stock="' + spl[4] + '" data-buy="' + spl[0] + '"></span></div></div></div>'))
    })), $(".box").on("click", (function() {
        $(".custom_dokup").remove(),
        $.get(file, (function(e) {
            $(".custom_dokup").length < 1 && $(".p-detail-inner").after('<div class="custom_dokup"><h2 class="doprodej-title hide">Výprodej kusových rozměrů</h2><div class="dokup"></div></div>'),
            lines = e.split("\r\n"),
            $(".p-detail-inner-header-mobile .p-code .parameter-dependent").length ? find_code = $('.p-detail-inner-header-mobile .p-code .parameter-dependent:not(".no-display")').text().trim() : find_code = $(".p-detail-inner-header-mobile .p-code td span").text().trim();
            for (var t = 0; t <= lines.length - 2; t++)
                radek = lines[t],
                spl = radek.split(";"),
                code = spl[0].split("//")[0],
                code === find_code && (pname = spl[2], price = spl[3], stock = spl[4], stock > 0 ? (stock = "Skladem", stock_class = stock.normalize("NFD").replace(/[^\w]/g, "").toLowerCase()) : (stock = "Není skladem", stock_class = "0"), $(".doprodej-title").removeClass("hide"), $(".dokup").append('<div class="product"><div class="name">' + pname + '</div><div class="right"><div class="availability"><span class="' + stock_class + '">' + stock + '</span></div><div class="cart"><p>' + price + ' Kč/ks</p><span data-stock="' + spl[4] + '" data-buy="' + spl[0] + '"></span></div></div></div>'))
        }))
    })), $("html").on("click", ".dokup .cart span", (function() {
        shoptet.cartShared.addToCart({
            productCode: $(this).attr("data-buy")
        })
    })))
}
const ParametricFilterSliders = function() {
    const e = {
        replaceFilterIds: [],
        enableInputFilterIds: [],
        strictInputs: !0,
        showSubmitBtn: !0,
        submitOnChange: !1,
        injectCss: !0,
        fallbackLang: "cs",
        trans: {
            cs: {
                fromValueChanged: e => `Počáteční hodnota byla změněna na ${e}.`,
                toValueChanged: e => `Koncová hodnota byla změněna na ${e}.`,
                fromValueInvalid: (e, t) => `Počáteční hodnota ${e} neexistuje.${t.length >= 2 ? ` Nejbližší možné jsou ${t.join(" a ")}.` : t.length > 0 ? ` Nejbližší možná je ${t[0]}.` : ""}`,
                toValueInvalid: (e, t) => `Koncová hodnota ${e} neexistuje.${t.length >= 2 ? ` Nejbližší možné jsou ${t.join(" a ")}.` : t.length > 0 ? ` Nejbližší možná je ${t[0]}.` : ""}`
            }
        }
    };
    let t;
    const a = {};
    function i(i, n) {
        const o = (i = $(i)).find("input[type=checkbox]"),
            r = o.first().data("filterId"),
            s = o.map((function() {
                const e = $(this),
                    t = e.attr("id").match(/([0-9]+)$/);
                return {
                    $el: e,
                    valueNumeric: tb.common.parseNumber(e.attr("value")),
                    value: e.attr("value"),
                    id: t && tb.common.parseNumber(t[1]),
                    disabled: !!e.prop("disabled"),
                    checked: e.is(":checked"),
                    url: e.data("url")
                }
            })).toArray();
        function l(e) {
            const t = o.first(),
                a = t.data("filterCode") + t.data("filterId");
            let i = s.filter((function(t, a) {
                return a >= e[0] && a <= e[1]
            }));
            e[0] === d && e[1] === c && (i = []),
            function(e, t, a) {
                const i = new RegExp("([?&])" + t + "=([0-9,]+)");
                let n = e.replace(i, "$1").replace(/[?&]+$/, "");
                a.length && (n += n.split("?")[1] ? "&" : "?", n += t + "=" + a.map((function(e) {
                    return e.id
                })).join(",")),
                makeFilterAjaxRequest(n, !0, !1, event.target, "ShoptetPagePriceFilterChange")
            }(t.data("url"), a, i)
        }
        s.sort((function(e, t) {
            return e.valueNumeric - t.valueNumeric
        })),
        i.addClass("has-parametric-slider");
        let d = s.length - 1,
            c = 0,
            p = s.length - 1,
            u = 0,
            h = !1;
        for (let A = 0; A < s.length; A++) {
            let j = s[A];
            !j.checked && j.disabled || (d = Math.min(d, A), c = Math.max(c, A)),
            j.checked && (h = !0, p = Math.min(p, A), u = Math.max(u, A))
        }
        function m(e) {
            return e ? " " + e : ""
        }
        d = 0,
        c = s.length - 1,
        h || (p = d, u = c);
        let v,
            f = "",
            g = "";
        const k = i.find("h4>span");
        function b(e) {
            return [Math.max(0, Math.min(e[0], e[1])), Math.min(s.length - 1, Math.max(e[0], e[1]))]
        }
        let _,
            y,
            w,
            x,
            S,
            C;
        if (k.length && (v = k.text().trim().match(/^(.+)\s*\[([^\]]+)\]$/)) ? (k.text(v[1]), g = f = v[2]) : s.length && (g = function(e) {
            let t = e.match(/^[0-9,.\s]+([^0-9,.\s].*)$/);
            return t ? t[1] : null
        }(s[0].value)), n) {
            let O,
                L,
                F,
                P;
            function T(e) {
                a[r] = e,
                x.text(e)
            }
            function z() {
                const a = tb.common.parseNumber(O.val()) || 0,
                    i = tb.common.parseNumber(L.val()) || 0;
                if (T(""), a === F && i === P)
                    return;
                let n,
                    o;
                for (n = c; n > d && !(s[n].valueNumeric <= a); n--)
                    ;
                for (o = d; o < c && !(s[o].valueNumeric >= i); o++)
                    ;
                const r = b([n, o]);
                let p = "";
                const u = s[r[0]],
                    h = s[r[1]];
                if (e.strictInputs) {
                    function v(e, t, a, i) {
                        const n = [a];
                        return a + i >= d && a + i <= c && n.push(a + i), n.sort(), e(t + m(g), n.map((e => s[e].value + m(f))))
                    }
                    if (u.valueNumeric !== a && (p += v(t.fromValueInvalid, a, r[0], 1)), h.valueNumeric !== i && (p += v(t.toValueInvalid, i, r[1], -1)), p)
                        return void T(p)
                } else
                    u.valueNumeric !== a && (p += t.fromValueChanged(u.value + m(f))),
                    h.valueNumeric !== i && (p += t.toValueChanged(h.value + m(f)));
                T(p),
                C(r),
                l(r),
                S.hide()
            }
            y = tb.$h("div.from", [tb.$h(".parametric-slider-input-wrapper", [O = tb.$h("input.form-control.form-control-sm.parametric-slider-input", {
                type: "text",
                inputmethod: "numeric"
            }), g ? tb.$h("span.parametric-slider-unit", m(g)) : null])]).toggleClass("has-unit", !!g),
            w = tb.$h("div.to", [tb.$h(".parametric-slider-input-wrapper", [L = tb.$h("input.form-control.form-control-sm.parametric-slider-input", {
                type: "text",
                inputmethod: "numeric"
            }), g ? tb.$h("span.parametric-slider-unit", m(g)) : null])]).toggleClass("has-unit", !!g),
            x = tb.$h("span.parametric-slider-msg").text(a[r] || ""),
            S = tb.$h("button.btn.parametric-slider-submit-btn", {
                type: "button"
            }, "Filtrovat").hide(),
            C = function(e) {
                F = s[e[0]].valueNumeric,
                P = s[e[1]].valueNumeric,
                O.val(F),
                L.val(P)
            },
            y.add(w).on("click focus", (function(e) {
                e.stopImmediatePropagation()
            })).on("input", (function(t) {
                T(""),
                e.showSubmitBtn && S.show()
            })),
            e.showSubmitBtn && !e.submitOnChange || y.add(w).on("change", z),
            S.on("click", z),
            $(document).on("keypress", (function(e) {
                13 == e.which && z()
            }))
        } else
            y = tb.$h("span.from"),
            w = tb.$h("span.to"),
            C = function(e) {
                const t = s[e[0]],
                    a = s[e[1]];
                y.text(t.value + m(f)),
                w.text(a.value + m(f))
            };
        i.find("form").before(tb.$h(".parametric-slider-wrapper", [tb.$h(".slider-content", [_ = tb.$h(".parametric-slider")]), tb.$h(".slider-header", [y, w]), x || S ? tb.$h(".slider-footer", [x, S]) : null])),
        C([p, u]),
        _.slider({
            range: !0,
            min: d,
            max: c,
            values: [p, u],
            slide: function(e, t) {
                const a = b(t.values);
                C(a)
            },
            stop: function(e, t) {
                const a = b(t.values);
                C(a),
                l(a)
            }
        })
    }
    return {
        init: tb.dom.createModuleInitializer({
            earlyInit: function() {
                if (!$("body.type-category").length)
                    return !1;
                t = function() {
                    const t = getShoptetDataLayer(),
                        a = t ? t.language : e.fallbackLang;
                    return e.trans[a] || e.trans[e.fallbackLang] || {}
                }()
            },
            domReady: function() {
                e.injectCss && tb.$h("style", "\n        .filter-section.has-parametric-slider>form {display:none!important;}\n        .parametric-slider-input {max-width:60px;height:2em;text-align:center;}\n        .parametric-slider-input-wrapper {display:inline-flex;align-items:center}\n        .parametric-slider-msg {font-size: 0.9em;color: #f00;}\n        .parametric-slider-wrapper .slider-footer {text-align:center}\n\n      ").appendTo("head")
            },
            render: function() {
                $(".filter-section-parametric").each((function() {
                    const t = $(this).find("input[type=checkbox]").first().data("filterId");
                    e.replaceFilterIds.includes(t) && tb.dom.oneTime(this, "ParametricFilterSliders") && i(this, e.enableInputFilterIds.includes(t))
                }))
            }
        }),
        config: e
    }
}();
if (ParametricFilterSliders.config.replaceFilterIds = [193, 190], ParametricFilterSliders.config.enableInputFilterIds = [193, 190], ParametricFilterSliders.init(), $(".type-category").length) {
    function mhfiltr() {
        $('#filters, .filters').prepend('<h4 class="filterTitle">Filtrovat produkty<span class="closeFilter"></span></h4>');
        cat_filter = $("#category-filter-hover>div").length,
        cat_filter -= 1,
        $("#category-filter-hover").attr("number-of-filters", cat_filter),
        cat_filter > 4 && ($(".filter-sections").append('<div class="cat-filter-button"><span>Zobrazit podrobné vyhledávání</span></div>'), $(".filter-section:not(:nth-child(-n+4))").each((function() {
            $(this).find("label.active").length > 0 && ($(".filter-sections").addClass("open-it"), $(".cat-filter-button>span").text("Skrýt podrobné vyhledávání"))
        }))),
        $(".cat-filter-button>span").on("click", (function() {
            $(this).closest(".filter-sections").toggleClass("open-it"),
            $(".cat-filter-button>span").text("Zobrazit podrobné vyhledávání" == $(this).text() ? "Skrýt podrobné vyhledávání" : "Zobrazit podrobné vyhledávání")
        }));
        if($('.vybrane-filtry').length == 0) { 
            $('.filters-wrapper').prepend('<div class="vybrane-filtry"></div>'); 
        }
        $('.vybrane-filtry').html('')
        $(".filter-label.active").clone().appendTo(".vybrane-filtry");
        $('.filter-section.filter-section-count p').clone().appendTo(".vybrane-filtry")
        $(".vybrane-filtry .filter-label.active").closest("div").addClass("aktivni-filtr"); 
        $(".vybrane-filtry .filter-section fieldset div:not(.aktivni-filtr)").remove(); 
        $('.filter-section-count').append('<span class="hideFilter">Použít filtry</span>');
    }
    $('html').on('click', '.hideFilter', function(e){
        e.preventDefault();
        $('body').removeClass('filters-visible');
        $('#filters').removeClass('visible');
        $('.filters-unveil-button-wrapper .unveil-button').text('Otevřít filtr').attr('data-text', 'Zavřít filtr');
    });

    $(document).ready((function() {
        mhfiltr()
    })),
    document.addEventListener("ShoptetDOMPageContentLoaded", (function() {
        mhfiltr()
    }))
    $('html').on('click', '.closeFilter', function(){
        $(this).closest('#filters, .filters').removeClass('visible');
        $('.filters-unveil-button-wrapper a').text('Otevřít filtr').attr('data-text', 'Zavřít filtr');
        $('body').removeClass('filters-visible');
    })
}
$("footer#footer").length && ($("footer#footer .contact-us .center ul").append($('.custom-footer__contact .contact-box li:not(".social-icon-list")').clone()), $(".copyright").html("© " + (new Date).getFullYear() + " PODLAHY PLOTZ, podlahové centrum"), $(".logo-social .social ul").append($(".custom-footer__contact .contact-box .social-icon-list")), $(".kontakt-biox-footer").append($('.custom-footer__contact .contact-box li:not(".social-icon-list")').clone()), $("footer#footer").before($("footer#footer .custom-footer__newsletter")), $(".custom-footer__newsletter").wrapInner('<div class="footer-newsletter"><div class="container"></div></div>'), $(".footer-newsletter").after($("footer#footer .contact-us")), $(".footer-newsletter h2").text("Udělejte z domova milovaný DOMOV."), $(".custom-footer>div h4").on("click", (function() {
    $(this).closest(".custom-footer>div").toggleClass("open-footer")
}))),
$("#formNewsletterWidget").remove(),
$('<div class="footer__custom-register"><a href="/registrace" class="btn btn-default">Registrovat se</a></div>').appendTo(".footer-newsletter > .container"),
$(".tel a").each((function() {
    $(this).html((function() {
        return $(this).html().replace("+420", "<i style='font-weight:400'>+420</i>")
    }))
}));
var menuItems = $(".top-navigation-bar .top-navigation-bar-menu > li");
if (menuItems.length > 0) {
    var customMenu = '<li class="appended-category menu-item-3889 ext">\n        <a href="/informace-pro-vas/"><b>Informace pro Vás</b><span class="submenu-arrow"></span></a>\n        <ul class="menu-level-2 menu-level-2-appended" id="customMenu"></ul>\n    </li>';
    $(customMenu).appendTo(".navigation-in .menu-level-1"),
    menuItems.clone().appendTo("#customMenu")
}
if ($("header#header").length && ($(".header-top .container").append($("footer#footer .prodejna-top")), $(".top-navigation-bar .container").append('<div class="main-contact"><ul>' + $('.custom-footer__contact .contact-box li:not(".social-icon-list")').closest(".contact-box ul").clone().html() + "</ul></div>"), $(".header-top .container").append($('.navigation-buttons a[data-target="navigation"]')), $(".header-top .container .navigation-buttons").append($('.top-navigation-bar .container a[data-target="login"]').clone()), $(".navigationActions").before($(".top-navigation-menu .top-navigation-bar-menu").clone())), $(".menu-level-1 > .appended-category > a").click((() => {
    $(this).parent().toggleClass("exp"),
    event.preventDefault()
})), $(".in-index").length) {
    var seensitovina = {};
    function mhslider() {
        $(".realizace-feed").slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            dots: !1,
            arrow: !0,
            responsive: [{
                breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 330,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        })
    }
    $(".in-index .product:not(.naposledy-navs)").each((function() {
        $(this).attr("data-sku", "code-" + $(this).find('span[data-micro="sku"]').text());
        var e = $(this).data("sku");
        seensitovina[e = "code-" + e] ? $(this).remove() : seensitovina[e] = !0
    })),
    /*
    header_height = $("header#header").height(),
    top_bar = $(".top-navigation-bar").height(),
    top_carousel = header_height + top_bar + 1,
    $(".banners-row #carousel").insertAfter("header#header").attr("style", "margin-top:-" + top_carousel + "px"),
    $(window).resize((function() {
        header_height = $("header#header").height(),
        top_bar = $(".top-navigation-bar").height(),
        top_carousel = header_height + top_bar + 1,
        $("#carousel").attr("style", "margin-top:-" + top_carousel + "px")
    })),
    */
        
        /*
    $(".products-wrapper #products-1").after('<div class="text-center"><a href="/akce/" class="btn btn-black">Další produkty</a></div>'),
    $(".welcome").prepend('<div class="left"></div>'),
    $(".welcome h1").appendTo(".welcome-wrapper .left"),
    $(".welcome>div h2:not(.nomove)").appendTo(".welcome-wrapper .left"),
    $("main#content").append($("footer#footer .realizace")),
    $("main#content").append($("footer#footer .counter")),
    $(".homepage-blog-wrapper").append('<div class="text-center"><a href="/blog/" class="btn btn-next">Další články</a></div>'),
    */
        $(document).ready((function () {
        /*
        $.ajax({
            type: "GET",
            dataType: "html",
            timeout: 1e4,
            cache: !0,
            url: "/nase-realizace/",
            success: function(e) {
                var t = shoptet.common.createDocumentFromString(e),
                    a = $(t).find("#newsWrapper").html();
                null !== a && ($(".realizace-feed").html(a), mhslider())
            }
        }),
        rate_count = $("#hodnoceniobchodu .rate-average-inner .stars-label").text(),
        $("#hodnoceniobchodu .rate-average-inner .stars-label").remove(),
        $('<a href="/hodnoceni-obchodu/" class="text-under">' + rate_count + "</a>").appendTo("#hodnoceniobchodu .rate-star-wrap")
        */
    }))
}
/*-
$(document).ready((function() {
    $("body").addClass("ready"),
    //$(".container-narrow:has(.blog-wrapper)").insertBefore("#footer"),
    //$(".custom-footer__newsletter").insertBefore("#footer")
})),
    */
    /*
$(".counter strong span").each((function() {
    $(this).prop("Counter", 0).animate({
        Counter: $(this).text()
    }, {
        duration: 4e3,
        easing: "swing",
        step: function(e) {
            $(this).text(Math.ceil(e).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))
        }
    })
})),
*/
/*
document.addEventListener("DOMContentLoaded", (function() {
    setTimeout((() => {
        $("#hodnoceniobchodu").insertBefore(".custom-footer__newsletter")
    }), 500),
    setTimeout((() => {
        document.getElementById("hodnoceniobchodu").style.opacity = 1
    }), 550)
}));
*/
var ua = window.navigator.userAgent,
    msie = ua.indexOf("MSIE "),
    trident = ua.indexOf("Trident/");
function truncateHtml(e, t) {
    const a = (new DOMParser).parseFromString(e, "text/html");
    let i = 0;
    const n = function e(a) {
        if (i >= t)
            return;
        const n = a.cloneNode();
        return a.nodeType === Node.TEXT_NODE ? i + a.textContent.length > t ? (n.textContent = a.textContent.slice(0, t - i) + "...", i = t) : (n.textContent = a.textContent, i += a.textContent.length) : a.nodeType === Node.ELEMENT_NODE && Array.from(a.childNodes).forEach((t => {
            const a = e(t);
            a && n.appendChild(a)
        })), n
    }(a.body).innerHTML;
    return n
}


function toggleExpandableText(selector, expandText, collapseText, maxLength) {
    $(selector).each(function () {
        const $element = $(this);
        if ($element.find('.full-text').length > 0) return;

        const fullHtml = $element.html().trim();
        const fullText = $element.text().trim();

        if (fullText.length <= maxLength) return;

        let truncatedHtml = "";
        let currentLength = 0;
        let isTruncated = false;

        $element.contents().each(function () {
            if (!isTruncated) {
                let tempHtml = $(this).prop('outerHTML') || $(this).text();
                currentLength += $(this).text().length;

                if (currentLength > maxLength) {
                    isTruncated = true;
                    let cutIndex = tempHtml.indexOf(" ", maxLength - (currentLength - $(this).text().length));
                    if (cutIndex > 0) {
                        tempHtml = tempHtml.substring(0, cutIndex) + "... ";
                    } else {
                        tempHtml += "... ";
                    }
                }

                truncatedHtml += tempHtml;
            }
        });

        const $fullWrapper = $('<div class="full-text" style="display: none;"></div>').html(fullHtml);
        const $truncatedWrapper = $('<div class="truncated-text"></div>').html(truncatedHtml);

        const $expandLink = $('<span class="toggle-text-link" style="cursor:pointer;"></span>').text(expandText);
        const $collapseLink = $('<span class="toggle-text-link" style="cursor:pointer;"></span>').text(collapseText);

        $expandLink.on('click', function () {
            $truncatedWrapper.hide();
            $fullWrapper.show();
        });

        $collapseLink.on('click', function () {
            $fullWrapper.hide();
            $truncatedWrapper.show();
        });

        $truncatedWrapper.find('p').last().append($expandLink);
        $fullWrapper.find('p').last().append($collapseLink);

        $element.empty().append($truncatedWrapper, $fullWrapper);
    });
}








if ((msie > 0 || trident > 0) && alert("Internet Explorer není­ podporovaný prohlížeč. Aktualizujte prosím na modernější variantu, například Google Chrome, atd. Děkujeme za pochopení."), $(".menu-level-2 div").click((function() {
    $(this).find(".menu-level-3").toggleClass("active")
})), $(".in-montaze.type-posts-listing").length && ($(".odbornici-flex").html($(".content-inner>#newsWrapper")), sessionStorage.realizace_montaze ? $(".realizace-montaze .realizace-inner").append(sessionStorage.realizace_montaze) : $(document).on("ready", (function() {
    $(".realizace-montaze .realizace-inner").load("/nase-realizace/ #newsWrapper>article", (function() {
        sessionStorage.realizace_montaze = $(".realizace-montaze .realizace-inner").html()
    }))
})), $(".pagination-wrapper").after('<div class="usp-page"><div class="container"></div></div>'), sessionStorage.usp_page ? $(".usp-page .container").append(sessionStorage.usp_page) : $(document).on("ready", (function() {
    $(".usp-page .container").load("/ .benefitBanner .usp", (function() {
        sessionStorage.usp_page = $(".usp-page .container").html()
    }))
}))), $(".products").length) {
    function mhproduct() {
        $(".product:not(.naposledy-navs)").each((function() {
            find_discount = $(this).find(".flag-discount"),
            find_prices = $(this).find(".prices");
            var e = $(this).find(".availability"),
                t = $(this).find(".p-bottom>div");
            $(e).appendTo(t),
            find_variant = $(this).find(".widget-parameter-wrapper"),
            find_image = $(this).find("a.image"),
            find_more = $(this).find(".widget-parameter-more"),
            $(find_variant).length > 0 && $(find_variant).appendTo(find_image),
            find_discount.length > 0 && $(find_prices).prepend(find_discount),
            $(this).find(".price-save").length && ($($(this).find(".price-save")).each((function() {
                $(this).html((function() {
                    return $(this).html().replace("(", "")
                })),
                $(this).html((function() {
                    return $(this).html().replace(")", "")
                }))
            })), $(this).find(".image").append($(this).find(".price-save")))
        }))
    }
    mhproduct(),
    document.addEventListener("ShoptetDOMPageContentLoaded", (function() {
        mhproduct()
    })),
    document.addEventListener("ShoptetDOMPageMoreProductsLoaded", (function() {
        mhproduct()
    }))
    document.addEventListener("dkLabFavouriteProductsLoaded", (function() {
        mhproduct()
    }))
}
function hideCouterParametr() {
    if (document.body.classList.contains("type-product")) {
        const e = document.querySelectorAll(".surcharge-list");
        e.length && e.forEach((e => {
            const t = e.querySelector(".info-text");
            if (t) {
                t.textContent.trim().includes("[counter]") && (e.classList.add("hidden"), e.classList.add("counter-parameter"))
            }
        }))
    }
}
async function getCounter() {
    let e = 1,
        t = null;
    const a = `${window.location.origin}/action/Cart/GetCartContent/?simple_ajax_cart=1`,
        i = await fetch(a),
        n = (await i.json()).payload.content;
    if (t = (new DOMParser).parseFromString(n, "text/html"), t) {
        const a = t.querySelectorAll(".cart-widget-product-surcharges");
        if (a.length) {
            const t = [];
            a.forEach((e => {
                e.textContent.trim().replace("Příplatky: ", "").split(", ").forEach((e => {
                    e.includes("Řez - Řez ") && (e = e.replace("Řez - Řez ", "").replace(".", ""), t.push(parseInt(e)))
                }))
            })),
            t.length && (e = Math.max(...t) + 1)
        }
    }
    return console.log("counter", e), e
}
async function increaseCounter() {
    if (document.body.classList.contains("type-product")) {
        let e = await getCounter();
        const t = document.querySelector(".counter-parameter");
        if (t) {
            t.querySelector("select").querySelectorAll("option").forEach(((t, a) => {
                a === e && (t.selected = !0)
            }))
        }
    }
}
function variantBaleni() {
    document.querySelector(".variant-baleni") && ($("body").on("click", ".zadane-baleni-wrap span", (function() {
        setTimeout((function() {
            actual_val = $(".zadane-baleni-wrap input").val(),
            baleni_div = $(".select-variant .box.active"),
            baleni_div.length > 0 ? (baleni = parseFloat(baleni_div.attr("data-baleni")), new_bal = (baleni * actual_val).toFixed($(".add-to-cart .quantity input").attr("data-decimals"))) : new_bal = actual_val,
            $(".add-to-cart .quantity input").val(new_bal),
            $(".add-to-cart .quantity input").attr("value", new_bal);
            let e = $(".box.active .price").attr("data-price");
            e = parseFloat(e),
            price_final = e * new_bal,
            price_final = price_final,
            $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency()),
            $(".p-to-cart-block .celkem-plocha span").html(new_bal)
        }), 10)
    })), $("body").on("input", ".zadane-baleni-wrap", (function() {
        setTimeout((function() {
            actual_val = $(".zadane-baleni-wrap input").val(),
            baleni = parseFloat($(".select-variant .box.active").attr("data-baleni")),
            new_bal = (baleni * actual_val).toFixed($(".add-to-cart .quantity input").attr("data-decimals")),
            $(".add-to-cart .quantity input").val(new_bal),
            $(".add-to-cart .quantity input").attr("value", new_bal),
            price_final = parseFloat($('.price-final').find('>span:not(.no-display)').text().split('/')[0].replace(',', '.').replace(/ /g, '').trim().replace('€', '')) * new_bal,
            price_final = price_final,
            $(".celkem").html("Celkem " + price_final.ShoptetFormatAsCurrency()),
            $(".p-to-cart-block .celkem-plocha span").html(new_bal.replace(".", ","));
        }), 10)
    })))
}
function variantClick() {
    document.body.addEventListener("click", (function(e) {
        const t = e.target;
        if (t.classList.contains("box") || t.closest(".box")) {
            const e = t.classList.contains("active"),
                a = t.getAttribute("data-parameter-id"),
                i = t.getAttribute("data-val"),
                n = document.querySelectorAll('.var_inner:not([data-id="' + a + '"]) .box'),
                o = shoptet.variantsSplit.necessaryVariantData,
                r = document.querySelectorAll('select[data-parameter-id="' + a + '"] option');
            if (e)
                document.body.classList.add("disabled-add-to-cart"),
                t.classList.remove("active"),
                r.forEach((e => {
                    if (e.getAttribute("value") === i) {
                        e.selected = !1;
                        let t = new Event("change", {
                            bubbles: !0,
                            cancelable: !0
                        });
                        e.dispatchEvent(t)
                    }
                })),
                n.forEach((e => {
                    let t = !1;
                    for (const e in o)
                        if (e.includes(i)) {
                            t = !0;
                            break
                        }
                    e.classList.remove("available-true", "available-false"),
                    e.classList.add("available-" + t)
                }));
            else {
                r.forEach((e => {
                    if (e.getAttribute("value") === i) {
                        e.selected = !0;
                        let t = new Event("change", {
                            bubbles: !0,
                            cancelable: !0
                        });
                        e.dispatchEvent(t)
                    }
                })),
                n.forEach((e => {
                    const t = e.getAttribute("data-val");
                    let a = !1;
                    for (const e in o)
                        if (e.includes(i) && e.includes(t)) {
                            a = !0;
                            break
                        }
                    e.classList.remove("available-true", "available-false"),
                    e.classList.add("available-" + a)
                }));
                t.closest(".select-variant").setAttribute("data-code", a + "-" + i);
                document.querySelectorAll('.var_inner[data-id="' + a + '"] .box').forEach((e => e.classList.remove("active"))),
                t.classList.add("active");
                const e = document.querySelector(".parameter-id-" + a);
                e && (e.value = i),
                variant_find(i),
                find_price();
                const s = document.querySelectorAll(".variant-list").length,
                    l = document.querySelectorAll(".box.active").length,
                    d = document.querySelectorAll(".box.active.available-false").length > 0;
                s != l || d ? document.body.classList.add("disabled-add-to-cart") : document.body.classList.remove("disabled-add-to-cart")
            }
            if (t.classList.contains("box-obr")) {
                document.querySelector(".variant-list > div.parameter-id-" + a + ' input[value="' + i + '"]').click()
            }
        }
    }))
}
function variantCreateSelect() {
    $(".surcharge-list").length && ($(".p-to-cart-block").before('<div class="variant-wrap"></div>'), $(".surcharge-list select").each((function() {
        nadpis = $(this).closest(".surcharge-list").find(".surcharge-label").text(),
        nadpis.indexOf("#checkboxnote") > 0 ? ($(this).closest(".surcharge-list").find(".surcharge-label>span").length ? (find_surcharge_label = $(this).closest(".surcharge-list"), find_surcharge_label = find_surcharge_label.find(".surcharge-label>span").attr("title")) : find_surcharge_label = "", data_surcharge_id = $(this).data("parameter-id"), data_surcharge_text = $(this).data("parameter-name").trim().split("#")[0], click_box = '<div class="select-surcharge" data-id="' + data_surcharge_id + '">', click_box += '<div class="var_inner" data-id="' + data_surcharge_id + '">', $(this).find("option").each((function() {
            find_option_text = $(this).text(),
            surcharge_val = find_option_text.split("+")[0].trim(),
            find_surcharge_value = $(this).val(),
            $.isNumeric(find_surcharge_value) && (click_box += '<div class="surcharge-box-message" data-full-name="' + nadpis.replace("?", "").trim() + " - " + $(this).text() + '" data-val="' + find_surcharge_value + '" data-parameter-id="' + data_surcharge_id + '" data-value=' + surcharge_val + ">", click_box += '<div class="surcharge-title">' + data_surcharge_text + ". " + find_surcharge_label + "</div>", click_box += "</div>")
        })), click_box += "</div>", click_box += "</div>", $(".variant-wrap").append(click_box), $(".variant-wrap").before('<div class="narez-popup"><h3>Úprava rozměru na míru</h3><span class="close"></span><p>' + text_na_miru + '</p><textarea placeholder="Zadejte rozměr"></textarea><div class="left"><span class="potvrdit">Potvrzuji rozměr</span></div></div>'), $(this).closest(".surcharge-list").hide()) : nadpis.indexOf("#checkbox") > 0 ? ($(this).closest(".surcharge-list").find(".surcharge-label>span").length ? (find_surcharge_label = $(this).closest(".surcharge-list"), find_surcharge_label = find_surcharge_label.find(".surcharge-label>span").attr("title")) : find_surcharge_label = "", data_surcharge_id = $(this).data("parameter-id"), data_surcharge_text = $(this).data("parameter-name").trim().split("#")[0], priplatek = '<div class="select-surcharge" data-id="' + data_surcharge_id + '">', priplatek += '<div class="var_inner" data-id="' + data_surcharge_id + '">', $(this).find("option").each((function() {
            find_option_text = $(this).text(),
            surcharge_val = find_option_text.split("+")[0].trim(),
            find_surcharge_value = $(this).val(),
            $.isNumeric(find_surcharge_value) && (priplatek += '<div class="surcharge-box" data-val="' + find_surcharge_value + '" data-parameter-id="' + data_surcharge_id + '" data-value=' + surcharge_val + ">", priplatek += '<div class="surcharge-title">' + data_surcharge_text + ". " + find_surcharge_label + "</div>", priplatek += "</div>")
        })), priplatek += "</div>", priplatek += "</div>", $(".variant-wrap").append(priplatek), $(this).closest(".surcharge-list").hide()) : nadpis.indexOf("#info") > 0 ? ($(this).closest(".surcharge-list").find(".surcharge-label>span").length ? (find_surcharge_label = $(this).closest(".surcharge-list"), find_surcharge_label = find_surcharge_label.find(".surcharge-label>span").attr("title")) : find_surcharge_label = "", data_surcharge_id = $(this).data("parameter-id"), data_surcharge_text = $(this).data("parameter-name").trim().split("#")[0], priplatek = '<div class="select-surcharge" data-id="' + data_surcharge_id + '">', priplatek += '<div class="var_inner" data-id="' + data_surcharge_id + '">', $(this).find("option").each((function() {
            find_option_text = $(this).text(),
            surcharge_val = find_option_text.split("+")[0].trim(),
            find_surcharge_value = $(this).val(),
            $.isNumeric(find_surcharge_value) && (priplatek += '<div class="surcharge-box info" data-val="' + find_surcharge_value + '" data-parameter-id="' + data_surcharge_id + '" data-value=' + surcharge_val + ">", priplatek += '<div class="surcharge-title">' + data_surcharge_text + ". " + find_surcharge_label + "</div>", priplatek += "</div>")
        })), priplatek += "</div>", priplatek += "</div>", $(".variant-wrap").append(priplatek), $(this).closest(".surcharge-list").hide()) : ($(this).closest(".surcharge-list").find(".surcharge-label>span").length ? (find_surcharge_label = $(this).closest(".surcharge-list"), find_surcharge_label = find_surcharge_label.find(".surcharge-label>span").attr("title")) : find_surcharge_label = "", text_icka = '<div class="info-text">' + find_surcharge_label + "</div>", $(this).closest(".surcharge-list").find(".surcharge-label").after(text_icka), $(this).closest(".surcharge-list").find(".surcharge-label>span").replaceWith('<span class="open-text">?</span>'))
    })))
}
function variantLista() {
    $(".lista.p-variants-block").length && ($(".p-variants-block .variant-list").each((function() {
        html = '<div class="select-variant prechodovalista">',
        $(this).find("select option").length > 0 && (data_parameter_id = $(this).find("select").data("parameter-id"), html += "<h2>" + $(this).find(".variant-label").text().trim() + "</h2>", html += '<div class="var_inner" data-id="' + data_parameter_id + '">', $(this).find("select option").each((function() {
            find_option_text = $(this).text(),
            find_option_value = $(this).val();
            const e = shoptet.variantsSplit.necessaryVariantData;
            let t = !1;
            for (const a in e)
                if (a.includes(find_option_value)) {
                    t = !0;
                    break
                }
            ($(".p-final-price-wrapper .price-final>span").length = 1) ? (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder").text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent").html()) : (find_option_price = $(".p-to-cart-block .price-final").find(".price-final-holder." + data_parameter_id + "-" + find_option_value).text(), find_option_availability = $(".p-data-wrapper .detail-parameters").find(".parameter-dependent." + data_parameter_id + "-" + find_option_value).html()),
            attr_price = find_option_price.replace(",", ".").replace(/ /g, "").replace("€", ""),
            attr_price = parseFloat(attr_price),
            $.isNumeric(find_option_value) && (html += '<div class="box box-text available-' + t + '" data-val="' + find_option_value + '" data-parameter-id="' + data_parameter_id + '">', html += '<div class="text">' + find_option_text + "</div>", html += "</div>")
        })), html += "</div>"),
        $(this).find("select option").length < 1 && (data_parameter_id = $(this).find(".hidden-split-parameter").data("parameter-id"), html += "<h2>" + $(this).find(".variant-label").text().trim() + "</h2>", html += '<div class="var_inner" data-id="' + data_parameter_id + '">', $(this).find(".hidden-split-parameter>label").each((function() {
            find_option_text = $(this).find(".parameter-value").text(),
            find_option_value = $(this).find("input").attr("value"),
            find_option_image = $(this).find(".advanced-parameter-inner img").attr("data-src"),
            data_parameter_id = $(this).closest(".hidden-split-parameter").data("parameter-id"),
            html += '<div class="box box-obr" data-val="' + find_option_value + '" data-parameter-id="' + data_parameter_id + '">',
            html += '<div class="image"><img src="' + find_option_image + '"></div>',
            html += '<div class="text">' + find_option_text + "</div>",
            html += "</div>"
        })), html += "</div>"),
        html += "</div>",
        $(".p-to-cart-block").before(html)
    })), $(".variant-list").hide())
}
$('input[type="search"]').length && $('input[type="search"]').attr("placeholder", "Co hledáte? Např. koberec 90x200"),
$("html").on("click", ".increase", (function() {
    zaokrouhleni = $(this).closest(".quantity").find("input.amount").data("decimals"),
    zaokrouhleni = parseFloat(zaokrouhleni),
    get_minimal = $(this).closest(".quantity").find("input.amount").attr("min"),
    get_minimal = parseFloat(get_minimal),
    get_actual_amount = $(this).closest(".quantity").find("input.amount").val(),
    get_actual_amount = parseFloat(get_actual_amount),
    (0 == zaokrouhleni || get_minimal > 1) && (new_amount = (get_minimal + get_actual_amount - 1).toFixed(zaokrouhleni), $(this).closest(".quantity").find("input.amount").val(new_amount))
})),
$("html").on("click", ".decrease", (function() {
    zaokrouhleni = $(this).closest(".quantity").find("input.amount").data("decimals"),
    zaokrouhleni = parseFloat(zaokrouhleni),
    get_minimal = $(this).closest(".quantity").find("input.amount").attr("min"),
    get_minimal = parseFloat(get_minimal),
    get_actual_amount = $(this).closest(".quantity").find("input.amount").val(),
    get_actual_amount = parseFloat(get_actual_amount),
    (0 == zaokrouhleni || get_minimal > 1) && (get_actual_amount > get_minimal ? new_amount = (get_actual_amount - get_minimal + 1).toFixed(zaokrouhleni) : get_actual_amount == get_minimal && (new_amount = get_minimal.toFixed(zaokrouhleni)), $(this).closest(".quantity").find("input.amount").val(new_amount))
})),
document.addEventListener("DOMContentLoaded", (() => {
    hideCouterParametr(),
    increaseCounter()
})),
document.addEventListener("ShoptetDOMContentLoaded", (async () => {
    increaseCounter()
})),
isProductDetail && (variantCreateSelect(), variantLista(), variantBaleni(), variantClick());
//isProductDetail && (variantLista(), variantBaleni(), variantClick());
